export const listSVGIcon04 = {
  checkEnabled: (
    <svg
      width="70"
      height="70"
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.5" clipPath="url(#clip0_2178_12343)">
        <path
          d="M20.0547 12.5339C20.274 12.5653 20.4934 12.6279 20.744 12.6906L21.2454 13.9753L21.8721 12.816C22.3107 12.816 22.7494 12.8473 23.1881 12.8473L22.3421 11.7506C22.3734 11.6566 22.4047 11.5626 22.4361 11.4686C22.3421 11.4373 22.2481 11.4059 22.0601 11.3433C22.3421 11.0612 22.4674 10.9359 22.6241 10.9986C22.6867 10.8419 22.7494 10.6539 22.8121 10.4972C22.3734 10.6226 21.9347 10.8106 21.496 10.9672C21.2454 10.7792 20.9947 10.6226 20.744 10.4346C20.744 10.6539 20.7754 10.9046 20.6814 11.1866C20.556 10.9046 20.462 10.6852 20.368 10.5286C20.3994 10.8732 20.3994 11.2493 20.4307 11.5939C20.3994 11.6253 20.3367 11.6566 20.3054 11.7193C20.4307 11.7193 20.556 11.7193 20.7127 11.7193C20.7127 12.1266 20.556 12.3773 20.0547 12.5339Z"
          fill="#00C968"
        />
        <path
          d="M19.3965 12.4086C19.4592 12.4086 19.5218 12.44 19.5845 12.44C19.5845 12.3773 19.5845 12.3146 19.5845 12.252C19.4905 12.3146 19.4592 12.346 19.3965 12.4086Z"
          fill={"#00C968"}
        />
        <path
          d="M28.1686 8.30355C27.8866 7.95888 27.5732 7.6142 27.2599 7.26953C27.1659 7.73954 27.0719 8.17822 27.0092 8.64822L26.3825 8.93023L25.7559 9.24357C26.1945 9.43157 26.6019 9.61958 27.0092 9.83891L27.1972 11.1863L28.1059 10.2463C28.5446 10.3403 28.9519 10.4969 29.3593 10.6223L28.8266 9.3689C29.0773 8.9929 29.3279 8.58556 29.5786 8.20955C29.1086 8.20955 28.6386 8.27222 28.1686 8.30355Z"
          fill="#00C968"
        />
        <path
          d="M15.3846 16.9828L16.1992 18.0795C16.2932 17.6408 16.4186 17.2335 16.5439 16.7948C16.9513 16.6695 17.4213 16.6068 17.8286 16.5128L16.7319 15.6668C16.7633 15.2281 16.7946 14.7581 16.8573 14.2881C16.4499 14.5388 16.0739 14.8208 15.6979 15.0714C15.2592 14.9148 14.8205 14.7581 14.3819 14.6014C14.5072 15.0401 14.6639 15.4788 14.8205 15.9175C14.5385 16.2935 14.2565 16.6695 14.0059 17.0455C14.4759 17.0455 14.9145 17.0141 15.3846 16.9828Z"
          fill="#00C968"
        />
        <path
          d="M25.3802 50.2279C25.4116 49.9146 25.3802 49.8206 25.0669 49.6639C24.5969 49.4446 25.1296 49.1939 25.2549 48.9746C25.1296 48.8492 25.0669 48.7552 24.9102 48.5672C25.2549 48.4105 25.5682 48.2539 25.9129 48.0659C26.0696 48.5985 26.1949 49.0372 26.3203 49.5072C26.9783 49.5072 27.1976 50.0086 27.4796 50.6039C26.9156 50.4786 27.0409 50.3532 26.8216 51.0426L31.9604 54.0193C31.929 53.8 31.9917 53.612 32.211 53.5806C32.3364 53.5493 32.493 53.612 32.587 53.6746L35.1564 49.2252C35.0938 49.2252 35.0624 49.2566 34.9998 49.2566C34.9371 49.2566 34.8744 49.0999 34.8744 49.0686C34.9058 49.0059 34.9998 48.9432 35.1564 48.8492C35.1878 48.9432 35.2191 49.0059 35.2504 49.0686L36.3158 47.2512C36.1904 47.2199 36.0338 47.1885 35.7831 47.0945C36.0338 47.0005 36.2844 46.8752 36.5351 46.9065L37.3498 45.4652C37.2245 45.5278 37.0991 45.5905 36.9111 45.6218C36.5665 44.6818 36.8798 44.2118 37.9138 44.2118C37.8825 44.3685 37.8511 44.4938 37.8198 44.6505L43.1152 35.501C43.0526 35.5636 43.0212 35.595 42.9272 35.6576C42.9586 35.1876 42.9899 34.9056 43.3973 34.9996L46.8753 28.9835C46.844 28.9208 46.7813 28.7955 46.7186 28.6702C46.8127 28.6702 46.938 28.6702 47.032 28.7015L52.0141 20.0533L42.7706 14.7266L28.4196 39.6057L19.3015 34.3416L13.9434 43.6164L25.3802 50.2279Z"
          fill="#00C968"
        />
        <path
          d="M0 34.9999C0 35.1252 0 35.2193 0 35.3446C0.0626679 35.3133 0.125336 35.2819 0.250671 35.2819C0.282005 35.2819 0.407341 35.4386 0.376007 35.4386C0.282005 35.5639 0.219338 35.7206 0.0940018 35.7833C0.0626679 35.7833 0.0313339 35.8146 0 35.8146C0.0313339 37.6633 0.219338 39.4807 0.564011 41.2667C0.658013 41.204 0.72068 41.11 0.783348 40.9847C0.87735 40.7967 1.25336 40.734 1.53536 40.6087C1.62936 40.0447 1.03402 40.2013 0.814682 39.9507C0.689346 39.4807 0.595345 39.0107 0.407341 38.3213C1.06535 38.7913 1.37869 39.3867 1.9427 39.6687C2.09937 39.7313 2.25604 39.8253 2.41271 39.9193C2.38138 39.606 2.31871 39.324 2.28738 39.0107C1.97404 39.1047 1.69203 39.1673 1.41003 38.854C0.814682 38.1646 1.09669 37.5066 1.12802 37.2873C1.53536 37.1306 1.8487 37.068 2.09937 37.162C2.06804 36.8486 2.06804 36.5353 2.03671 36.1906C1.97404 36.1906 1.9427 36.1593 1.88004 36.1593C1.53536 36.0026 1.7547 35.8146 1.91137 35.5639C1.9427 35.5953 1.97404 35.6266 2.00537 35.6579C1.9427 33.0572 2.19338 30.4878 2.75739 28.0124C2.50671 27.7931 2.44405 27.6051 2.50671 27.3858C2.56938 27.1978 2.69472 27.1038 2.97672 27.1351C5.54611 16.7322 13.0976 7.86473 23.6571 4.01066C23.5631 3.91666 23.4691 3.82265 23.3438 3.72865C23.5945 3.66599 23.7511 3.60332 24.0018 3.54065C23.9705 3.66599 23.9705 3.79132 23.9705 3.91666C24.5658 3.69732 25.1925 3.50932 25.8192 3.32131C25.7252 3.03931 25.5998 2.72597 25.4745 2.34996C25.7878 2.44396 27.0412 2.60063 26.7278 3.07064C31.5533 1.81728 36.4414 1.69195 41.0475 2.5693C41.0161 2.53796 41.0161 2.53796 40.9848 2.50663C41.6115 2.34996 41.6741 2.31863 41.9561 2.7573C42.7081 2.91397 43.4288 3.10197 44.1495 3.32131C44.1808 3.28998 44.2122 3.22731 44.2748 3.16464C44.3062 3.25864 44.3375 3.32131 44.3689 3.38398C48.0663 4.48067 51.513 6.20403 54.615 8.49141C54.615 8.39741 54.615 8.27207 54.5837 8.05274C55.1791 8.33474 55.1164 8.14674 54.9597 8.71075C54.9284 8.71075 54.8971 8.67941 54.8657 8.67941C60.5372 12.9408 64.8926 19.0823 66.8666 26.4458C71.5667 43.9927 61.1012 62.1351 43.5542 66.8352C41.7995 67.3052 40.0448 67.6185 38.2587 67.8065C38.3841 67.9945 38.5721 68.1512 38.6034 68.3392C38.7287 69.1226 38.1334 69.1852 37.2874 69.5612C37.6321 68.9032 37.8827 68.3705 38.1647 67.8065C36.41 67.9632 34.624 67.9945 32.9006 67.9005C33.0573 68.0885 33.12 68.1825 32.9946 68.5899C32.9946 68.6212 32.744 68.6212 32.7126 68.5899C32.5246 68.2765 32.65 68.0572 32.744 67.9005C32.368 67.8692 31.9919 67.8379 31.6159 67.8065V67.8379C31.4906 67.8379 31.3966 67.8065 31.3339 67.7752C29.3912 67.5559 27.4485 67.1485 25.5998 66.5845C26.0072 67.0859 25.8818 67.2425 25.1298 67.6812C25.1611 67.4305 25.2865 67.1485 25.2238 67.0232C25.0985 66.8038 25.1298 66.6472 25.2238 66.4905C22.8111 65.7385 20.4924 64.7045 18.3304 63.4198C17.923 63.4198 17.829 63.4198 17.735 63.0751C17.4843 62.9184 17.2337 62.7618 17.0143 62.6051C16.9517 62.6678 16.9517 62.6364 16.795 62.5424C16.795 62.5111 16.8263 62.5111 16.8263 62.4798C10.3402 58.187 5.3581 51.6069 3.19606 43.5541C2.97672 42.7394 2.78872 41.8934 2.63205 41.0787C2.50671 41.0787 2.38138 41.0474 2.19338 41.016C1.8487 41.6114 1.50403 42.1754 0.814682 42.3321C1.00269 43.1781 1.22202 44.0241 1.44136 44.8701C1.50403 44.8074 1.62936 44.7448 1.7547 44.6508C1.6607 44.8074 1.59803 44.9954 1.50403 45.1521C2.38138 48.0975 3.66607 50.8862 5.2641 53.4556L5.29543 53.4243C5.51477 53.2363 5.0761 52.5469 5.82811 52.6722C5.89078 53.1423 5.89078 53.5496 5.48344 53.8629C5.51477 53.9256 5.54611 53.9883 5.60877 54.0509C5.67144 54.0196 5.79678 53.9883 6.01612 53.9256C5.92211 54.0196 5.85945 54.1449 5.76544 54.2703C11.8442 63.4824 22.1531 69.6866 33.9346 70.0312C33.9033 69.9999 33.872 69.9372 33.8406 69.9059C34.0287 69.9686 34.1853 69.9999 34.3107 70.0312C34.53 70.0312 34.7807 70.0312 35 70.0312C43.4915 70.0312 51.2623 67.0232 57.3098 61.9784C57.1218 61.9784 57.0591 61.9471 57.1844 61.5397C57.4351 61.7591 57.4664 61.7591 57.4664 61.8218C61.7905 58.2184 65.2059 53.5496 67.368 48.2855C67.2113 48.3795 67.0546 48.5048 66.8666 48.6302C66.8666 48.1915 66.9606 47.9095 67.3366 47.8155C67.368 47.8155 67.4306 47.8782 67.4933 47.9408C67.5873 47.7215 67.6813 47.4708 67.7753 47.2515C67.7126 47.2515 67.65 47.2515 67.5873 47.2515C67.6813 47.1261 67.8066 47.0008 67.932 46.8128C68.0573 46.4681 68.1826 46.1235 68.2766 45.7788C68.2453 45.7788 68.214 45.8101 68.1826 45.8414C68.308 45.4341 68.4333 45.0268 68.5586 44.5881C68.59 44.5881 68.6213 44.5881 68.6213 44.6194C68.684 44.3688 68.7466 44.1181 68.8406 43.8674C68.778 43.7734 68.8406 43.6481 68.9347 43.4287C69.5927 40.734 69.9687 37.914 69.9687 34.9999C69.9687 25.4431 66.1459 16.7636 59.9105 10.4654C59.8791 10.4654 59.8165 10.4968 59.7851 10.5281C59.4405 10.3714 59.3465 10.1208 59.3151 9.8701C56.6831 7.33205 53.6437 5.17001 50.3223 3.54065C50.291 3.57198 50.2283 3.60332 50.197 3.66599C50.197 3.60332 50.197 3.54065 50.197 3.50932C47.9409 2.34996 45.4655 1.50394 42.9275 0.9086C42.7708 1.19061 42.5515 1.44128 42.2068 1.62928C42.0188 1.75462 41.8308 1.91129 41.5801 1.62928C41.8621 1.47261 41.8621 0.971268 42.3635 1.06527C42.3948 1.06527 42.5201 0.939934 42.5515 0.845932C42.2695 0.783264 41.9875 0.720596 41.7055 0.657928C41.5488 0.75193 41.3295 0.877266 41.0475 1.03394C40.8908 0.814598 40.8908 0.657929 40.9221 0.532593C40.7341 0.501259 40.5148 0.469925 40.3268 0.438591C40.2954 0.595261 40.2954 0.814598 40.3268 1.15927C40.0448 1.37861 39.7628 1.62928 39.4494 1.87995C39.4181 1.66061 39.2928 1.44128 39.3241 1.25327C39.3868 0.814598 39.3868 0.501259 39.2928 0.281921C37.9141 0.125252 36.4727 0.03125 35.0313 0.03125C32.65 0.03125 30.2999 0.281921 28.0439 0.720596C28.0439 0.783264 28.0752 0.877266 28.0439 1.0026C27.8245 0.939934 27.6679 0.877266 27.5739 0.783264C26.4145 1.03394 25.2551 1.34727 24.1271 1.72328C23.9705 1.87995 23.8765 1.91129 23.7511 1.84862C9.93286 6.54871 0 19.615 0 34.9999Z"
          fill="#00C968"
        />
        <path
          d="M8.4283 35.3137C8.36564 30.5823 9.55633 25.9135 12.0004 21.7148L10.183 20.6494C6.36026 27.2922 5.32624 35.0004 7.33162 42.3952C9.30565 49.79 14.0684 55.9628 20.6799 59.8168L21.7452 57.9995C15.6978 54.5214 11.3424 48.9126 9.46232 42.1758C9.46232 42.2385 9.43099 42.2385 9.30565 42.3012C9.05498 41.9252 9.05498 42.0192 9.36832 41.8625C8.96098 40.2958 8.67898 38.7291 8.55364 37.1624C8.52231 37.1937 8.49097 37.2564 8.49097 37.2564C8.52231 38.0397 7.89563 38.1651 7.36295 38.5098C7.17495 38.1337 7.01828 37.8204 6.83027 37.4757C7.17495 37.3817 7.58229 37.3504 7.80162 37.1311C8.02096 36.9431 8.08363 36.5357 8.20897 36.2537C7.98963 36.003 7.80163 35.815 7.58229 35.5644C7.86429 35.345 8.0523 35.1884 8.2403 35.0004C8.27163 35.0944 8.30297 35.157 8.4283 35.3137Z"
          fill="#00C968"
        />
        <path
          d="M35.2824 7.45746C35.0944 7.05012 34.875 6.61144 34.6557 6.2041C34.4677 6.61144 34.2483 7.05012 34.0603 7.45746C33.5903 7.52013 33.1517 7.61413 32.6816 7.73947C33.0576 8.02147 33.4023 8.30348 33.747 8.61682L33.5903 9.99551C33.9663 9.74484 34.311 9.5255 34.7184 9.30616C35.0944 9.49417 35.4704 9.74484 35.8464 9.96417L35.627 8.61682C35.9717 8.30348 36.3164 7.99014 36.6611 7.70813C36.2224 7.55146 35.7524 7.52013 35.2824 7.45746Z"
          fill="#00C968"
        />
        <path
          d="M48.5983 56.8081L48.097 55.5234L47.4703 56.6828C47.0316 56.6828 46.593 56.6515 46.1543 56.6515L47.0003 57.7482C46.875 58.1868 46.7183 58.6255 46.5303 59.0328C46.969 58.9075 47.4077 58.7195 47.8463 58.5628C48.2223 58.8448 48.5983 59.0955 49.0057 59.3462C48.9743 58.8762 48.943 58.4062 48.9117 57.9675C49.2877 57.6855 49.6324 57.3721 49.977 57.0588C49.4757 56.9961 49.037 56.9021 48.5983 56.8081Z"
          fill="#00C968"
        />
        <path
          d="M41.1424 61.1634C41.4244 61.508 41.7377 61.884 42.051 62.2287C42.145 61.7587 42.2391 61.32 42.3017 60.85L42.9284 60.568L43.5551 60.2547C43.2417 60.1293 42.9597 59.9727 42.6777 59.8473C42.6777 59.8787 42.6777 59.8787 42.6464 59.91C42.4271 60.2547 42.0824 59.8787 41.2364 59.252C40.7977 59.158 40.3903 59.0013 39.983 58.876L40.5157 60.1293C40.265 60.5053 40.0143 60.9127 39.7637 61.2887C40.2337 61.2574 40.6724 61.1947 41.1424 61.1634Z"
          fill="#00C968"
        />
        <path
          d="M42.2703 59.1899L42.145 58.2812L41.2363 59.2213C41.7063 59.0959 42.051 59.0959 42.2703 59.1899Z"
          fill="#00C968"
        />
        <path
          d="M34.0291 62.041C34.2171 62.4483 34.4364 62.887 34.6558 63.2943C34.8438 62.887 35.0631 62.4483 35.2511 62.041C35.7211 61.9783 36.1598 61.8843 36.6298 61.759C36.2538 61.477 35.9091 61.195 35.5645 60.8816L35.7211 59.5029C35.3451 59.7536 35.0004 59.9729 34.5931 60.1923C34.2171 60.0043 33.8411 59.7536 33.4651 59.5343L33.6844 60.8816C33.3397 61.195 32.9951 61.5083 32.6504 61.7903C33.1204 61.9156 33.5591 61.947 34.0291 62.041Z"
          fill="#00C968"
        />
        <path
          d="M41.3929 9.99536C41.7062 10.3087 42.0196 10.622 42.3329 10.9354L42.4582 9.55669C42.8656 9.33735 43.2729 9.11801 43.6803 8.93001C43.2729 8.71067 42.8342 8.554 42.3956 8.366C42.3016 7.92732 42.2076 7.45731 42.1136 6.9873C41.8002 7.33198 41.5182 7.70799 41.2362 8.08399C40.7662 8.05266 40.2962 8.02132 39.8262 7.98999C40.1082 8.366 40.3902 8.71067 40.6409 9.11801L40.1395 10.4027L41.3929 9.99536Z"
          fill="#00C968"
        />
        <path
          d="M27.2288 62.4481C27.5421 62.1034 27.8241 61.7274 28.1062 61.3514C28.5762 61.3827 29.0462 61.4141 29.5162 61.4454C29.2342 61.0694 28.9522 60.7247 28.7015 60.3174L29.2028 59.0327L27.9495 59.44C27.6361 59.1267 27.3228 58.8133 27.0095 58.5L26.8841 59.8787C26.4768 60.098 26.0695 60.3174 25.6621 60.5054C26.0695 60.7247 26.5081 60.8814 26.9468 61.0694V61.1007C27.0095 61.0067 27.0721 60.9127 27.1661 60.8187C27.4168 61.038 27.6361 61.226 27.9182 61.4454C27.5108 61.5394 27.2601 61.6334 27.0721 61.6647C27.1348 61.9781 27.1661 62.1974 27.2288 62.4481Z"
          fill="#00C968"
        />
        <path
          d="M53.9577 52.4844L53.143 51.3877C53.049 51.8264 52.9237 52.2337 52.7984 52.6724C52.391 52.7977 51.921 52.8604 51.5137 52.9544L52.6104 53.8004C52.579 54.2391 52.5477 54.7091 52.485 55.1791C52.8924 54.9284 53.2684 54.6464 53.6444 54.3958C54.0831 54.5524 54.5217 54.7091 54.9604 54.8658C54.8351 54.4271 54.6784 53.9884 54.5217 53.5497C54.8037 53.1737 55.0857 52.7977 55.3364 52.4217C54.8664 52.4217 54.3964 52.453 53.9577 52.4844Z"
          fill="#00C968"
        />
        <path
          d="M54.1446 13.6304C52.6719 12.3144 51.0739 11.155 49.3505 10.1523L48.2852 11.9697C54.4266 15.5104 58.8134 21.2446 60.6621 28.1067C60.8814 28.9214 61.0694 29.7674 61.1947 30.5821C61.3201 30.6134 61.4454 30.6761 61.5707 30.7701C61.5081 30.8954 61.4767 31.0834 61.3827 31.0834C61.3514 31.0834 61.3201 31.0834 61.2887 31.1147C61.3827 31.8041 61.4767 32.4934 61.5081 33.1514C61.5707 33.1828 61.6334 33.2454 61.6961 33.2768C61.6334 33.3394 61.5707 33.3708 61.5394 33.4021C61.6961 35.9402 61.4767 38.4782 60.9127 40.9223C61.2261 40.8283 61.5081 40.7343 61.8527 41.0476C61.9154 40.8283 61.9781 40.8909 61.4767 40.5462C61.1321 40.2956 61.1321 40.2956 61.5081 39.8256C61.7901 39.9196 61.8214 40.4522 62.2914 40.3269C62.3228 40.3269 62.4481 40.7029 62.4481 40.6716C62.3228 41.0476 61.9154 41.3923 62.4168 41.7683C62.1034 42.1443 61.8214 42.395 61.3514 42.4263C61.6647 42.9903 61.0694 43.1156 60.9441 43.4603C60.6621 43.4916 60.3801 43.4916 60.1294 43.523C59.722 44.7137 59.2207 45.873 58.6567 47.001C58.7507 47.0637 58.8447 47.1264 58.9387 47.189C58.6567 47.5024 58.5627 47.5964 58.312 47.6277C58.218 47.8157 58.124 48.0037 57.9987 48.1917L59.816 49.2571C63.6388 42.6143 64.6728 34.9061 62.6674 27.5113C61.2261 22.0906 58.2807 17.3278 54.2073 13.6617C54.0193 14.1004 54.1446 14.6644 53.5806 14.8524C52.9852 15.0404 52.6092 14.6331 52.2332 14.1318C52.8912 14.0064 53.2986 13.1604 54.1446 13.6304Z"
          fill="#00C968"
        />
        <path
          d="M61.3518 42.5205C61.4458 41.4864 61.6025 41.2358 61.0071 41.3298C61.1638 41.7371 60.6311 42.2385 61.3518 42.5205Z"
          fill="#00C968"
        />
      </g>
      <defs>
        <clipPath id="clip0_2178_12343">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  closeSigner: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6654 4.2735L11.7254 3.3335L7.9987 7.06016L4.27203 3.3335L3.33203 4.2735L7.0587 8.00016L3.33203 11.7268L4.27203 12.6668L7.9987 8.94016L11.7254 12.6668L12.6654 11.7268L8.9387 8.00016L12.6654 4.2735Z"
        fill="#222D4B"
      />
    </svg>
  ),
  iconPdf: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM16 12V9C16 8.45 15.55 8 15 8H13V13H15C15.55 13 16 12.55 16 12ZM14 9H15V12H14V9ZM18 11H19V10H18V9H19V8H17V13H18V11ZM10 11H11C11.55 11 12 10.55 12 10V9C12 8.45 11.55 8 11 8H9V13H10V11ZM10 9H11V10H10V9Z"
        fill="#222D4B"
      />
    </svg>
  ),
  trashIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
        fill="#E50500"
      />
    </svg>
  ),
  uploadProfile: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 24H22.5V15H28.5L18 4.5L7.5 15H13.5V24ZM18 8.745L21.255 12H19.5V21H16.5V12H14.745L18 8.745ZM7.5 27H28.5V30H7.5V27Z"
        fill="#00C968"
      />
    </svg>
  ),
  noticePartner: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4043 7H13.4043V9H11.4043V7ZM11.4043 11H13.4043V17H11.4043V11ZM12.4043 2C6.8843 2 2.4043 6.48 2.4043 12C2.4043 17.52 6.8843 22 12.4043 22C17.9243 22 22.4043 17.52 22.4043 12C22.4043 6.48 17.9243 2 12.4043 2ZM12.4043 20C7.9943 20 4.4043 16.41 4.4043 12C4.4043 7.59 7.9943 4 12.4043 4C16.8143 4 20.4043 7.59 20.4043 12C20.4043 16.41 16.8143 20 12.4043 20Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  partner: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 6H17V4C17 2.89 16.11 2 15 2H9C7.89 2 7 2.89 7 4V6H4C2.89 6 2 6.89 2 8V19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM9 4H15V6H9V4ZM20 19H4V17H20V19ZM20 14H4V8H7V10H9V8H15V10H17V8H20V14Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  exportStatistic: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 9H15V3H9V9H5L12 16L19 9ZM11 11V5H13V11H14.17L12 13.17L9.83 11H11ZM5 18H19V20H5V18Z"
        fill="white"
      />
    </svg>
  ),
  editTypeConfig: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  configTypeProfile: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4308 12.98C19.4708 12.66 19.5008 12.34 19.5008 12C19.5008 11.66 19.4708 11.34 19.4308 11.02L21.5408 9.37C21.7308 9.22 21.7808 8.95 21.6608 8.73L19.6608 5.27C19.5708 5.11 19.4008 5.02 19.2208 5.02C19.1608 5.02 19.1008 5.03 19.0508 5.05L16.5608 6.05C16.0408 5.65 15.4808 5.32 14.8708 5.07L14.4908 2.42C14.4608 2.18 14.2508 2 14.0008 2H10.0008C9.75082 2 9.54082 2.18 9.51082 2.42L9.13082 5.07C8.52082 5.32 7.96082 5.66 7.44082 6.05L4.95082 5.05C4.89082 5.03 4.83082 5.02 4.77082 5.02C4.60082 5.02 4.43082 5.11 4.34082 5.27L2.34082 8.73C2.21082 8.95 2.27082 9.22 2.46082 9.37L4.57082 11.02C4.53082 11.34 4.50082 11.67 4.50082 12C4.50082 12.33 4.53082 12.66 4.57082 12.98L2.46082 14.63C2.27082 14.78 2.22082 15.05 2.34082 15.27L4.34082 18.73C4.43082 18.89 4.60082 18.98 4.78082 18.98C4.84082 18.98 4.90082 18.97 4.95082 18.95L7.44082 17.95C7.96082 18.35 8.52082 18.68 9.13082 18.93L9.51082 21.58C9.54082 21.82 9.75082 22 10.0008 22H14.0008C14.2508 22 14.4608 21.82 14.4908 21.58L14.8708 18.93C15.4808 18.68 16.0408 18.34 16.5608 17.95L19.0508 18.95C19.1108 18.97 19.1708 18.98 19.2308 18.98C19.4008 18.98 19.5708 18.89 19.6608 18.73L21.6608 15.27C21.7808 15.05 21.7308 14.78 21.5408 14.63L19.4308 12.98ZM17.4508 11.27C17.4908 11.58 17.5008 11.79 17.5008 12C17.5008 12.21 17.4808 12.43 17.4508 12.73L17.3108 13.86L18.2008 14.56L19.2808 15.4L18.5808 16.61L17.3108 16.1L16.2708 15.68L15.3708 16.36C14.9408 16.68 14.5308 16.92 14.1208 17.09L13.0608 17.52L12.9008 18.65L12.7008 20H11.3008L11.1108 18.65L10.9508 17.52L9.89082 17.09C9.46082 16.91 9.06082 16.68 8.66082 16.38L7.75082 15.68L6.69082 16.11L5.42082 16.62L4.72082 15.41L5.80082 14.57L6.69082 13.87L6.55082 12.74C6.52082 12.43 6.50082 12.2 6.50082 12C6.50082 11.8 6.52082 11.57 6.55082 11.27L6.69082 10.14L5.80082 9.44L4.72082 8.6L5.42082 7.39L6.69082 7.9L7.73082 8.32L8.63082 7.64C9.06082 7.32 9.47082 7.08 9.88082 6.91L10.9408 6.48L11.1008 5.35L11.3008 4H12.6908L12.8808 5.35L13.0408 6.48L14.1008 6.91C14.5308 7.09 14.9308 7.32 15.3308 7.62L16.2408 8.32L17.3008 7.89L18.5708 7.38L19.2708 8.59L18.2008 9.44L17.3108 10.14L17.4508 11.27ZM12.0008 8C9.79082 8 8.00082 9.79 8.00082 12C8.00082 14.21 9.79082 16 12.0008 16C14.2108 16 16.0008 14.21 16.0008 12C16.0008 9.79 14.2108 8 12.0008 8ZM12.0008 14C10.9008 14 10.0008 13.1 10.0008 12C10.0008 10.9 10.9008 10 12.0008 10C13.1008 10 14.0008 10.9 14.0008 12C14.0008 13.1 13.1008 14 12.0008 14Z"
        fill="#F57C00"
      />
    </svg>
  ),
  searchStatistic: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
        fill="#222D4B"
      />
    </svg>
  ),
  statistic: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19ZM7 10H9V17H7V10ZM11 7H13V17H11V7ZM15 13H17V17H15V13Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  warningInactive: (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.9997 93.333C63.6663 93.333 66.6663 90.333 66.6663 86.6663H53.333C53.333 90.333 56.333 93.333 59.9997 93.333ZM79.9997 73.333V56.6663C79.9997 46.433 74.5663 37.8663 64.9997 35.5997V33.333C64.9997 30.5663 62.7663 28.333 59.9997 28.333C57.233 28.333 54.9997 30.5663 54.9997 33.333V35.5997C45.4663 37.8663 39.9997 46.3997 39.9997 56.6663V73.333L33.333 79.9997V83.333H86.6663V79.9997L79.9997 73.333ZM73.333 76.6663H46.6663V56.6663C46.6663 48.3997 51.6997 41.6663 59.9997 41.6663C68.2997 41.6663 73.333 48.3997 73.333 56.6663V76.6663Z"
        fill="#F57C00"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#F57C00" strokeDasharray="5 5" />
    </svg>
  ),
  closeTab: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="10" fill="white" />
      <path
        d="M14.6668 6.2735L13.7268 5.3335L10.0002 9.06016L6.2735 5.3335L5.3335 6.2735L9.06016 10.0002L5.3335 13.7268L6.2735 14.6668L10.0002 10.9402L13.7268 14.6668L14.6668 13.7268L10.9402 10.0002L14.6668 6.2735Z"
        fill="#323232"
      />
    </svg>
  ),
  defaultAvatar: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#F4F4F4" />
      <path
        d="M20 14C21.1 14 22 14.9 22 16C22 17.1 21.1 18 20 18C18.9 18 18 17.1 18 16C18 14.9 18.9 14 20 14ZM20 23C22.7 23 25.8 24.29 26 25V26H14V25.01C14.2 24.29 17.3 23 20 23ZM20 12C17.79 12 16 13.79 16 16C16 18.21 17.79 20 20 20C22.21 20 24 18.21 24 16C24 13.79 22.21 12 20 12ZM20 21C17.33 21 12 22.34 12 25V28H28V25C28 22.34 22.67 21 20 21Z"
        fill="#626262"
      />
    </svg>
  ),
  bigLogo: (
    <svg
      width="264"
      height="45"
      viewBox="0 0 264 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M28.2558 27.1657C28.186 23.1565 27.8372 20.2532 27.0698 18.2486C26.3023 16.1058 24.7674 14.5159 22.6047 13.6173C20.5814 12.7878 17.6512 12.373 13.7442 12.373C9.69767 12.373 6.76744 12.9952 4.81395 14.3085C2.7907 15.6219 1.46512 17.5574 0.837209 19.9767C0.27907 22.1887 0 25.2993 0 29.3085C0 32.2118 0.209302 34.6311 0.55814 36.4975C0.976744 38.5021 1.67442 40.0919 2.7907 41.3362C3.83721 42.5804 5.37209 43.5482 7.32558 44.1012C9.13953 44.6542 11.5814 44.8615 14.4419 44.8615C17.5116 44.8615 19.9535 44.6542 21.7674 44.2394C23.7907 43.8247 25.3953 42.7878 26.5116 41.1979C27.6977 39.6772 28.2558 37.3961 28.2558 34.3546V33.3178H21.4884V35.3224C21.4884 37.8108 20.5116 38.2256 20.1628 38.433C19.0465 38.986 17.2326 39.1933 14.9302 39.1933H13.7442C11.4419 39.1933 9.76744 38.8477 8.86047 38.1565C7.95349 37.4652 7.39535 36.5666 7.18605 35.4606C6.97674 34.2855 6.83721 32.6265 6.83721 30.4836H28.3256V27.1657H28.2558ZM6.76744 24.9537C6.83721 23.1565 7.04651 21.7048 7.39535 20.7371C7.74419 19.7002 8.37209 19.009 9.34884 18.5942C10.3953 18.1104 12 17.903 14.1628 17.903C16.6047 17.903 18.4186 18.1104 19.4651 18.5942C20.3721 18.9399 20.9302 19.562 21.1395 20.5297C21.4186 21.4975 21.5581 23.0182 21.6279 25.0919H6.76744V24.9537Z"
          fill="#0D99FF"
        />
        <path
          d="M66.2791 30.9677C66.2094 30.1382 66.2094 29.5161 66.2094 29.1014V28.0645H59.3721V29.1014C59.3721 29.5853 59.3721 30.4147 59.4419 31.5207C59.5117 32.6267 59.5117 33.3871 59.5117 33.871C59.4419 35.7373 58.6745 36.9124 57.1396 37.6037C55.3954 38.3641 53.0931 38.7097 50.3721 38.7097C49.8838 38.7097 49.1861 38.7097 48.2791 38.6406C47.3721 38.5714 46.7442 38.5714 46.3954 38.5714C42.2094 38.5714 39.628 37.8111 38.7908 36.4286C37.7442 34.5622 37.2559 30.8295 37.2559 25.2304V15.4147C37.2559 13.2719 37.3954 11.5438 37.7442 10.2995C38.0233 9.19355 38.5815 8.36406 39.4187 7.74194C40.3256 7.11982 41.6512 6.70507 43.4652 6.56682C46.7442 6.35945 49.7442 6.2212 52.3954 6.2212C54.4187 6.2212 55.9535 6.4977 56.8605 7.05069C57.6977 7.53456 58.2559 8.22581 58.4652 9.19355C58.7442 10.3687 58.8838 12.0968 58.8838 14.447V15.4839H65.7907L65.721 14.3779C65.5117 11.3364 65.1628 8.84793 64.7442 7.05069C64.2559 5.18433 63.4187 3.66359 62.2326 2.62673C61.1163 1.58986 59.5117 0.898618 57.628 0.483871C55.8838 0.207373 53.4419 0 50.3721 0C46.5349 0 43.7442 0.138249 41.9303 0.345622C38.9303 0.691244 36.4884 1.52074 34.7442 2.8341C33.0001 4.14747 31.7442 5.9447 31.0466 8.15668C30.4187 10.2304 30.0698 12.7189 30.0698 15.6912V22.4654C30.1396 24.47 30.2094 26.8203 30.2791 29.5853C30.4187 32.4194 30.7675 34.9078 31.4652 36.9816C32.1628 39.1244 33.4884 40.9217 35.3024 42.3733C37.1163 43.7558 39.6977 44.5853 42.907 44.7926H48.9768C51.2791 44.7926 53.5814 44.7235 55.8838 44.5853C62.721 43.9631 66.3489 39.9539 66.3489 33.1106C66.4187 32.5576 66.3489 31.8664 66.2791 30.9677Z"
          fill="#1F2A49"
        />
        <path
          d="M96.1394 18.3874C95.3022 16.1063 93.7673 14.4473 91.6045 13.5487C89.5115 12.6501 86.5115 12.2354 82.5347 12.2354C78.7673 12.2354 75.9766 12.7883 73.9533 13.8252C71.9301 14.9312 70.4649 16.6593 69.7673 19.0095C69.1394 21.1524 68.7905 24.1248 68.7905 27.7883V30.6224C68.7905 34.4934 69.2091 37.3966 70.1161 39.4012C71.0929 41.5441 72.6975 43.0648 74.9301 43.8943C77.0231 44.6547 79.9533 45.0003 83.7905 45.0003C87.9068 45.0003 90.9068 44.3091 92.9301 42.8575C94.9533 41.4059 96.2091 39.4012 96.6277 36.9819C97.0463 34.7699 97.2556 31.5902 97.2556 27.5118C97.2556 23.5026 96.9068 20.5303 96.1394 18.3874ZM90.4184 27.1662C90.4184 30.0695 90.4184 32.3506 90.3487 33.8713C90.2789 35.4612 89.9301 36.7054 89.4417 37.4658C88.9533 38.157 88.2557 38.6409 87.4184 38.8483C86.3719 39.1248 84.9766 39.263 83.1626 39.263H80.9301C78.3487 39.263 77.3022 38.7791 76.8836 38.3644C76.1859 37.604 75.3487 35.5994 75.3487 30.2768V26.8206C75.3487 23.9865 75.558 21.9128 75.9068 20.6685C76.1859 19.6317 76.8138 18.9404 77.7208 18.5948C78.7673 18.1801 80.5812 17.9036 83.1626 17.9036H84.1394C86.8603 17.9036 88.1161 18.3183 88.6743 18.733C89.4417 19.2169 89.9301 19.9773 90.1394 21.0142C90.2789 22.3275 90.4184 24.4012 90.4184 27.1662Z"
          fill="#1F2A49"
        />
        <path
          d="M125.861 17.0741C125.023 15.2769 123.698 13.9635 121.954 13.2032C120.209 12.4428 117.977 12.0972 115.116 12.0972C112.675 12.0972 110.512 12.4428 108.698 13.134C107.651 13.5488 106.744 14.1018 105.907 14.8621V12.7884H99.7676V44.5165H106.326V25.2999C106.326 20.1847 108.837 17.8345 114.14 17.8345C116.093 17.8345 117.489 18.0419 118.395 18.3875C119.163 18.7331 119.651 19.217 119.93 19.9774C120.279 20.876 120.419 22.3276 120.419 24.1939V44.5165H127.047V23.8483C127.047 21.0142 126.628 18.7331 125.861 17.0741Z"
          fill="#1F2A49"
        />
        <path
          d="M146.163 32.0044V34.9076C146.163 36.9813 145.814 37.9491 145.535 38.3638C145.256 38.8477 144.279 39.1242 142.884 39.1242C141 39.1242 140.442 38.7094 140.302 38.5021C140.093 38.2256 139.744 37.5343 139.744 35.5297V18.456H151.256V12.7878H139.744V5.66797H133.116V12.7878H129.209V18.456H133.116V35.5297C133.116 37.8108 133.396 39.6081 134.023 40.9214C134.651 42.373 135.768 43.4099 137.302 44.032C138.698 44.585 140.512 44.8615 142.884 44.8615C146.721 44.8615 149.372 43.8246 150.628 41.6818C151.814 39.6772 152.442 36.9122 152.442 33.0412V32.0044H146.163Z"
          fill="#1F2A49"
        />
        <path
          d="M168.349 12.0972C165.488 12.0972 163.116 12.8575 161.302 14.3783V12.7884H154.884V44.5165H161.442V23.7101C161.442 19.7009 163.326 17.8345 167.372 17.8345C169.116 17.8345 170.233 18.2492 170.721 19.0096C171.279 19.9774 171.628 21.4981 171.628 23.5718V24.6087H178.047V23.5718C178.047 14.1018 172.744 12.0972 168.349 12.0972Z"
          fill="#1F2A49"
        />
        <path
          d="M206.512 16.9353C205.395 15.2072 203.791 14.0321 201.698 13.4791C199.814 12.9952 197.233 12.7188 194.093 12.7188C189.768 12.7188 186.698 13.2717 184.605 14.3777C182.372 15.622 181.186 18.3178 181.186 22.3962V23.433H187.884V22.3962C187.884 22.1197 187.814 21.9123 187.744 21.6358C187.675 21.4284 187.675 21.3593 187.675 21.3593C187.675 20.1842 187.954 19.3547 188.581 18.9399C189.14 18.5252 190.465 17.9722 193.674 17.9722C196.116 17.9722 197.93 18.1105 198.977 18.4561C199.814 18.7326 200.372 19.2164 200.721 20.1151C201.14 21.1519 201.279 22.8109 201.279 25.1611V26.1289C200.581 25.645 199.744 25.2994 198.837 25.092C197.233 24.7464 195.209 24.539 192.768 24.539C190.116 24.539 187.954 24.7464 186.209 25.2303C184.326 25.7141 182.791 26.751 181.744 28.2026C180.698 29.6542 180.14 31.7971 180.14 34.4929C180.14 37.3271 180.628 39.4699 181.675 40.9906C182.721 42.5805 184.186 43.6174 186.14 44.1704C187.884 44.6542 190.186 44.9307 192.977 44.9307C195.488 44.9307 197.581 44.6542 199.256 44.1704C200.163 43.8939 201 43.4791 201.768 42.9261L201.628 44.3777H208.047V24.1934C208.116 20.9446 207.558 18.5943 206.512 16.9353ZM201.698 34.7694C201.698 36.2211 201.349 37.1888 200.581 37.8109C199.744 38.5022 198.768 38.9169 197.581 39.0552C196.326 39.2625 194.651 39.3317 192.768 39.3317C189.907 39.3317 188.651 38.7787 188.093 38.2948C187.326 37.6727 186.977 36.2211 186.977 34.0782C186.977 32.0045 187.465 31.3823 187.605 31.2441L187.675 31.175C188.093 30.7602 189.419 30.1381 193.326 30.1381H194.442C197.023 30.1381 198.977 30.4146 200.233 31.0367C201.209 31.5206 201.698 32.7648 201.698 34.7694Z"
          fill="#1F2A49"
        />
        <path
          d="M232.047 31.5894V32.6262C232.047 34.7691 231.837 36.2898 231.419 37.1884C231.07 37.9488 230.512 38.4327 229.605 38.7092C228.558 38.9857 226.884 39.1239 224.581 39.1239C222.279 39.1239 220.605 38.8474 219.628 38.2253C218.721 37.6723 218.163 36.9119 217.884 35.8059C217.605 34.5617 217.465 32.6262 217.465 30.1377V27.1654C217.465 24.3313 217.674 22.2576 218.023 20.9442C218.372 19.9073 218.93 19.147 219.907 18.8013C221.023 18.3175 222.837 18.1101 225.419 18.1101C227.093 18.1101 228.419 18.2483 229.326 18.594C230.093 18.8705 230.581 19.2852 230.93 19.9765C231.349 20.7368 231.488 21.9119 231.488 23.5709V24.6078H237.907V22.6032C237.907 18.594 236.651 15.8981 234.279 14.4465C232.047 13.1331 228.907 12.4419 224.86 12.4419C221.163 12.4419 218.372 12.9258 216.279 14.0318C214.116 15.1377 212.651 16.7967 211.814 19.0778C211.047 21.2207 210.628 24.1239 210.628 27.7184C210.628 31.0364 210.767 33.6631 210.977 35.4603C211.186 37.3958 211.814 39.1239 212.721 40.5064C213.698 41.958 215.163 43.064 217.186 43.7553C219.07 44.4465 221.581 44.723 224.86 44.723C228.209 44.723 230.721 44.4465 232.605 43.8244C234.628 43.1331 236.163 41.8889 237.14 40.0917C238.047 38.3636 238.535 35.9442 238.535 32.6953V31.6585H232.047V31.5894Z"
          fill="#1F2A49"
        />
        <path
          d="M257.721 32.0044V34.9076C257.721 36.9813 257.372 37.9491 257.093 38.3638C256.814 38.8477 255.837 39.1242 254.442 39.1242C252.558 39.1242 252 38.7094 251.861 38.5021C251.651 38.2256 251.302 37.5343 251.302 35.5297V18.456H262.814V12.7878H251.302V5.66797H244.675V12.7878H240.768V18.456H244.675V35.5297C244.675 37.8108 244.954 39.6081 245.582 40.9214C246.209 42.373 247.326 43.4099 248.861 44.032C250.256 44.585 252.07 44.8615 254.442 44.8615C258.279 44.8615 260.93 43.8246 262.186 41.6818C263.372 39.6772 264 36.9122 264 33.0412V32.0044H257.721Z"
          fill="#1F2A49"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="264" height="45" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  signMethod: (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.6665 40L63.3332 33.3333H36.6665V90H43.3332V66.6667H59.9998L63.3332 73.3333H86.6665V40H66.6665ZM79.9998 66.6667H66.6665L63.3332 60H43.3332V40H59.9998L63.3332 46.6667H79.9998V66.6667Z"
        fill="#0D99FF"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#0D99FF" strokeDasharray="5 5" />
    </svg>
  ),
  trashRed: (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M40.0003 83.3333C40.0003 87 43.0003 90 46.667 90H73.3337C77.0003 90 80.0003 87 80.0003 83.3333V43.3333H40.0003V83.3333ZM46.667 50H73.3337V83.3333H46.667V50ZM71.667 33.3333L68.3337 30H51.667L48.3337 33.3333H36.667V40H83.3337V33.3333H71.667Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  logoutIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 7L9.6 8.4L12.2 11H2V13H12.2L9.6 15.6L11 17L16 12L11 7ZM20 19H12V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3H12V5H20V19Z"
        fill="#222D4B"
      />
    </svg>
  ),
  updateUnit: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z"
        fill="white"
      />
    </svg>
  ),
  warningCKS: (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9148 5.99L20.4156 19H5.41406L12.9148 5.99ZM12.9148 2L1.95752 21H23.8722L12.9148 2ZM13.911 16H11.9187V18H13.911V16ZM13.911 10H11.9187V14H13.911V10Z"
        fill="#F57C00"
      />
    </svg>
  ),
  warningAmber: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 5.99L19.53 19H4.47L12 5.99ZM12 2L1 21H23L12 2ZM13 16H11V18H13V16ZM13 10H11V14H13V10Z"
        fill="#E50500"
      />
    </svg>
  ),
  arrowDownTree: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 4.5L8 12L0.5 4.5"
        stroke="#868E96"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  undo: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 16H16C19.866 16 23 12.866 23 9C23 5.134 19.866 2 16 2H9"
        stroke="#219653"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 11L2 16L7 21"
        stroke="#219653"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  refresh: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 6V9L16 5L12 1V4C7.58 4 4 7.58 4 12C4 13.57 4.46 15.03 5.24 16.26L6.7 14.8C6.25 13.97 6 13.01 6 12C6 8.69 8.69 6 12 6ZM18.76 7.74L17.3 9.2C17.74 10.04 18 10.99 18 12C18 15.31 15.31 18 12 18V15L8 19L12 23V20C16.42 20 20 16.42 20 12C20 10.43 19.54 8.97 18.76 7.74Z"
        fill="#00C968"
      />
    </svg>
  ),
  "refresh-blue": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33398 7.99998C1.33398 4.33331 4.33398 1.33331 8.00065 1.33331C10.6007 1.33331 12.8673 2.79998 13.934 4.99998"
        stroke="#448AFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6664 8C14.6664 11.6667 11.6664 14.6667 7.99974 14.6667C5.39974 14.6667 3.13307 13.2 2.06641 11"
        stroke="#448AFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5333 1.13336L14 5.0667L10 4.53336"
        stroke="#448AFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.4668 14.8667L2.00013 10.9333L6.00013 11.4667"
        stroke="#448AFF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  users: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.992 18.7371L8.2 20.4001C8.704 20.7781 9 21.3701 9 22.0001V23.0001H1V22.0001C1 21.3701 1.296 20.7781 1.8 20.4001L4.008 18.7371"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.992 5.73706L15.2 7.40006C15.704 7.77806 16 8.37006 16 9.00006V10.0001H8V9.00006C8 8.37006 8.296 7.77806 8.8 7.40006L11.008 5.73706"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.992 18.7371L22.2 20.4001C22.704 20.7781 23 21.3701 23 22.0001V23.0001H15V22.0001C15 21.3701 15.296 20.7781 15.8 20.4001L18.008 18.7371"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  restore: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6C12.5523 6 13 6.44772 13 7V11.5858L16.7071 15.2929C17.0976 15.6834 17.0976 16.3166 16.7071 16.7071C16.3166 17.0976 15.6834 17.0976 15.2929 16.7071L11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12V7C11 6.44772 11.4477 6 12 6Z"
        fill="#24B8CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.20019 7.06373C3.96759 3.41846 7.71737 1 12 1C18.0523 1 23 5.94772 23 12C23 18.0523 18.0523 23 12 23C5.94772 23 1 18.0523 1 12C1 11.4477 1.44772 11 2 11C2.55228 11 3 11.4477 3 12C3 16.9477 7.05228 21 12 21C16.9477 21 21 16.9477 21 12C21 7.05228 16.9477 3 12 3C8.48263 3 5.43241 4.98154 3.99981 7.93627C3.75887 8.43323 3.16068 8.64076 2.66373 8.39981C2.16677 8.15887 1.95924 7.56068 2.20019 7.06373Z"
        fill="#24B8CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.09664 1.58406C2.64116 1.49172 3.15742 1.85828 3.24976 2.4028L3.91857 6.34687L7.86264 5.67806C8.40716 5.58572 8.92342 5.95228 9.01576 6.4968C9.10809 7.04131 8.74153 7.55757 8.19702 7.64991L3.26702 8.48591C3.00554 8.53025 2.73715 8.4689 2.5209 8.31536C2.30465 8.16181 2.15825 7.92865 2.11391 7.66717L1.27791 2.73717C1.18557 2.19266 1.55213 1.67639 2.09664 1.58406Z"
        fill="#24B8CC"
      />
    </svg>
  ),
  back: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C8 1.44772 8.44772 1 9 1H16C20.4183 1 24 4.58172 24 9C24 13.4183 20.4183 17 16 17H2C1.44772 17 1 16.5523 1 16C1 15.4477 1.44772 15 2 15H16C19.3137 15 22 12.3137 22 9C22 5.68628 19.3137 3 16 3H9C8.44772 3 8 2.55228 8 2Z"
        fill="#219653"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.70711 10.2929C8.09763 10.6834 8.09763 11.3166 7.70711 11.7071L3.41421 16L7.70711 20.2929C8.09763 20.6834 8.09763 21.3166 7.70711 21.7071C7.31658 22.0976 6.68342 22.0976 6.29289 21.7071L1.29289 16.7071C0.902369 16.3166 0.902369 15.6834 1.29289 15.2929L6.29289 10.2929C6.68342 9.90237 7.31658 9.90237 7.70711 10.2929Z"
        fill="#219653"
      />
    </svg>
  ),
  remove: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4142 12.0002L17.7072 7.70725C18.0982 7.31625 18.0982 6.68425 17.7072 6.29325C17.3162 5.90225 16.6842 5.90225 16.2933 6.29325L12.0002 10.5862L7.70725 6.29325C7.31625 5.90225 6.68425 5.90225 6.29325 6.29325C5.90225 6.68425 5.90225 7.31625 6.29325 7.70725L10.5862 12.0002L6.29325 16.2933C5.90225 16.6842 5.90225 17.3162 6.29325 17.7072C6.48825 17.9022 6.74425 18.0002 7.00025 18.0002C7.25625 18.0002 7.51225 17.9022 7.70725 17.7072L12.0002 13.4142L16.2933 17.7072C16.4882 17.9022 16.7443 18.0002 17.0002 18.0002C17.2562 18.0002 17.5122 17.9022 17.7072 17.7072C18.0982 17.3162 18.0982 16.6842 17.7072 16.2933L13.4142 12.0002Z"
        fill="#616161"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="6"
        y="6"
        width="13"
        height="13"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4142 12.0002L17.7072 7.70725C18.0982 7.31625 18.0982 6.68425 17.7072 6.29325C17.3162 5.90225 16.6842 5.90225 16.2933 6.29325L12.0002 10.5862L7.70725 6.29325C7.31625 5.90225 6.68425 5.90225 6.29325 6.29325C5.90225 6.68425 5.90225 7.31625 6.29325 7.70725L10.5862 12.0002L6.29325 16.2933C5.90225 16.6842 5.90225 17.3162 6.29325 17.7072C6.48825 17.9022 6.74425 18.0002 7.00025 18.0002C7.25625 18.0002 7.51225 17.9022 7.70725 17.7072L12.0002 13.4142L16.2933 17.7072C16.4882 17.9022 16.7443 18.0002 17.0002 18.0002C17.2562 18.0002 17.5122 17.9022 17.7072 17.7072C18.0982 17.3162 18.0982 16.6842 17.7072 16.2933L13.4142 12.0002Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)" />
    </svg>
  ),
  "filter-main": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00018 6H17.0002L11.9902 12.3L7.00018 6ZM4.25018 5.61C6.27018 8.2 10.0002 13 10.0002 13V19C10.0002 19.55 10.4502 20 11.0002 20H13.0002C13.5502 20 14.0002 19.55 14.0002 19V13C14.0002 13 17.7202 8.2 19.7402 5.61C20.2502 4.95 19.7802 4 18.9502 4H5.04018C4.21018 4 3.74018 4.95 4.25018 5.61Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  "filter-white1": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.99969 6H16.9997L11.9897 12.3L6.99969 6ZM4.24969 5.61C6.26969 8.2 9.99969 13 9.99969 13V19C9.99969 19.55 10.4497 20 10.9997 20H12.9997C13.5497 20 13.9997 19.55 13.9997 19V13C13.9997 13 17.7197 8.2 19.7397 5.61C20.2497 4.95 19.7797 4 18.9497 4H5.03969C4.20969 4 3.73969 4.95 4.24969 5.61Z"
        fill="white"
      />
    </svg>
  ),
  "box-confirm": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7071 16.2929C23.0976 16.6834 23.0976 17.3166 22.7071 17.7071L17.7071 22.7071C17.3166 23.0976 16.6834 23.0976 16.2929 22.7071L14.2929 20.7071C13.9024 20.3166 13.9024 19.6834 14.2929 19.2929C14.6834 18.9024 15.3166 18.9024 15.7071 19.2929L17 20.5858L21.2929 16.2929C21.6834 15.9024 22.3166 15.9024 22.7071 16.2929Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 2C0 1.44772 0.447715 1 1 1H23C23.5523 1 24 1.44772 24 2V12C24 12.5523 23.5523 13 23 13C22.4477 13 22 12.5523 22 12V3H2V21H10C10.5523 21 11 21.4477 11 22C11 22.5523 10.5523 23 10 23H1C0.447715 23 0 22.5523 0 22V2Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4933 4.09558C11.8433 4.26069 12.0667 4.61297 12.0667 5.00001V7.39811C13.5323 7.5105 15.0816 7.89853 16.3582 8.84625C17.986 10.0547 19 12.043 19 15C19 15.4438 18.7075 15.8345 18.2816 15.9595C17.8558 16.0845 17.3985 15.9139 17.1586 15.5405C15.9136 13.6021 14.0982 12.8713 12.0667 12.7055V15C12.0667 15.387 11.8433 15.7393 11.4933 15.9044C11.1432 16.0696 10.7293 16.0179 10.4307 15.7717L4.364 10.7717C4.13351 10.5817 4 10.2987 4 10C4 9.70133 4.13351 9.41829 4.364 9.22833L10.4307 4.22833C10.7293 3.98217 11.1432 3.93046 11.4933 4.09558ZM6.57232 10L10.0667 12.88V11.6667C10.0667 11.1144 10.5144 10.6667 11.0667 10.6667C12.8672 10.6667 14.7811 10.9756 16.4404 12.0328C16.1114 11.3266 15.6632 10.8211 15.1661 10.4521C14.0907 9.65379 12.6097 9.36084 11.0667 9.36084C10.5144 9.36084 10.0667 8.91313 10.0667 8.36084V7.12005L6.57232 10Z"
        fill="#27AE60"
      />
    </svg>
  ),
  "check-list": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 6C11 5.44772 11.4477 5 12 5H23C23.5523 5 24 5.44772 24 6C24 6.55228 23.5523 7 23 7H12C11.4477 7 11 6.55228 11 6Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 3C1 2.44772 1.44772 2 2 2H8C8.55228 2 9 2.44772 9 3V9C9 9.55228 8.55228 10 8 10H2C1.44772 10 1 9.55228 1 9V3ZM3 4V8H7V4H3Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 18C11 17.4477 11.4477 17 12 17H23C23.5523 17 24 17.4477 24 18C24 18.5523 23.5523 19 23 19H12C11.4477 19 11 18.5523 11 18Z"
          fill="#EB5757"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7071 13.2929C11.0976 13.6834 11.0976 14.3166 10.7071 14.7071L4.70711 20.7071C4.31658 21.0976 3.68342 21.0976 3.29289 20.7071L1.29289 18.7071C0.902369 18.3166 0.902369 17.6834 1.29289 17.2929C1.68342 16.9024 2.31658 16.9024 2.70711 17.2929L4 18.5858L9.29289 13.2929C9.68342 12.9024 10.3166 12.9024 10.7071 13.2929Z"
          fill="#EB5757"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "handout-2": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.5 9C5.67157 9 5 9.67157 5 10.5C5 11.3284 5.67157 12 6.5 12C7.32843 12 8 11.3284 8 10.5C8 9.67157 7.32843 9 6.5 9ZM3 10.5C3 8.567 4.567 7 6.5 7C8.433 7 10 8.567 10 10.5C10 12.433 8.433 14 6.5 14C4.567 14 3 12.433 3 10.5Z"
          fill="#27AE60"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 12C24 11.4477 23.5523 11 23 11H22C21.3492 11 20.2719 11.124 19.1976 11.4598C18.2997 11.7404 17.2686 12.2106 16.5281 13H14C12.3643 13 10.912 13.7856 9.99972 15H5C3.32232 15 2.2698 15.6124 1.66114 16.3773C1.37282 16.7397 1.21171 17.1021 1.12193 17.3773C1.07682 17.5156 1.04873 17.6348 1.03132 17.7254C1.02259 17.7709 1.01646 17.8096 1.01219 17.8404C1.01006 17.8558 1.00838 17.8693 1.00707 17.8808L1.00537 17.8964L1.00471 17.903L1.00442 17.9061L1.00429 17.9075C1.00422 17.9082 1.00416 17.9089 2 18L1.00416 17.9089C0.963396 18.3544 1.22348 18.7728 1.64102 18.9333L13.4057 23.4582C13.4058 23.4583 13.4056 23.4582 13.4057 23.4582C14.4555 23.8623 15.6264 23.8048 16.6312 23.3024L23.4472 19.8944C23.786 19.725 24 19.3788 24 19V12ZM3.3817 17.46C3.63075 17.2423 4.09907 17 5 17H9.10003C9.03444 17.3231 9 17.6575 9 18C9 18.5523 9.44771 19 10 19H17C17.5523 19 18 18.5523 18 18C18 17.4477 17.5523 17 17 17H11.1707C11.5826 15.8349 12.6939 15 14 15H17C17.3262 15 17.6319 14.8409 17.8191 14.5737C18.1762 14.0637 18.893 13.6504 19.7942 13.3687C20.6701 13.095 21.5458 13 22 13V18.382L15.7368 21.5136C15.2337 21.7651 14.6484 21.7936 14.1243 21.5918L3.3817 17.46Z"
          fill="#27AE60"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.7071 0.292893C21.0976 0.683417 21.0976 1.31658 20.7071 1.70711L14.7071 7.70711C14.3166 8.09763 13.6834 8.09763 13.2929 7.70711L11.2929 5.70711C10.9024 5.31658 10.9024 4.68342 11.2929 4.29289C11.6834 3.90237 12.3166 3.90237 12.7071 4.29289L14 5.58579L19.2929 0.292893C19.6834 -0.0976311 20.3166 -0.0976311 20.7071 0.292893Z"
          fill="#27AE60"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  cheque: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 11C0 10.4477 0.447715 10 1 10H6C6.55228 10 7 10.4477 7 11C7 11.5523 6.55228 12 6 12H2V21H22V12H17C16.4477 12 16 11.5523 16 11C16 10.4477 16.4477 10 17 10H23C23.5523 10 24 10.4477 24 11V22C24 22.5523 23.5523 23 23 23H1C0.447715 23 0 22.5523 0 22V11Z"
        fill="#24B8CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.2929 1.29289C14.6834 0.902369 15.3166 0.902369 15.7071 1.29289L18.7071 4.29289C19.0976 4.68342 19.0976 5.31658 18.7071 5.70711L9.70711 14.7071C9.51957 14.8946 9.26522 15 9 15H6C5.44772 15 5 14.5523 5 14V11C5 10.7348 5.10536 10.4804 5.29289 10.2929L14.2929 1.29289ZM7 11.4142V13H8.58579L16.5858 5L15 3.41421L7 11.4142Z"
        fill="#24B8CC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 18C5 17.4477 5.44772 17 6 17H18C18.5523 17 19 17.4477 19 18C19 18.5523 18.5523 19 18 19H6C5.44772 19 5 18.5523 5 18Z"
        fill="#24B8CC"
      />
    </svg>
  ),
  "curved-previous": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3827 2.07615C10.7564 2.23093 11 2.59557 11 3.00003V7.02266C13.6775 7.14467 16.6994 7.78362 19.1713 9.50429C22.0179 11.4858 24 14.8085 24 20C24 20.4513 23.6978 20.8467 23.2623 20.965C22.8268 21.0834 22.366 20.8954 22.1376 20.5062C20.8447 18.3035 19.6007 16.9885 17.8759 16.1806C16.2711 15.429 14.1535 15.0694 11 15.0092V19C11 19.4045 10.7564 19.7691 10.3827 19.9239C10.009 20.0787 9.57889 19.9931 9.29289 19.7071L1.29289 11.7071C0.902369 11.3166 0.902369 10.6834 1.29289 10.2929L9.29289 2.29292C9.57889 2.00692 10.009 1.92137 10.3827 2.07615ZM3.41421 11L9 16.5858V14C9 13.4477 9.44772 13 10 13C13.7848 13 16.5429 13.3478 18.7241 14.3694C19.8286 14.8867 20.756 15.5624 21.5819 16.405C20.9399 13.9086 19.6174 12.2516 18.0287 11.1458C15.7141 9.5346 12.6976 9.00003 10 9.00003C9.44772 9.00003 9 8.55231 9 8.00003V5.41424L3.41421 11Z"
        fill="#9B51E0"
      />
    </svg>
  ),
  "g-chart": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 14C1 13.4477 1.44772 13 2 13H6C6.55228 13 7 13.4477 7 14V20C7 20.5523 6.55228 21 6 21H2C1.44772 21 1 20.5523 1 20V14ZM3 15V19H5V15H3Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9C9 8.44772 9.44772 8 10 8H14C14.5523 8 15 8.44772 15 9V20C15 20.5523 14.5523 21 14 21H10C9.44772 21 9 20.5523 9 20V9ZM11 10V19H13V10H11Z"
        fill="#27AE60"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 4C17 3.44772 17.4477 3 18 3H22C22.5523 3 23 3.44772 23 4V20C23 20.5523 22.5523 21 22 21H18C17.4477 21 17 20.5523 17 20V4ZM19 5V19H21V5H19Z"
        fill="#27AE60"
      />
    </svg>
  ),
  handout: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5 8C16.6716 8 16 8.67157 16 9.5C16 10.3284 16.6716 11 17.5 11C18.3284 11 19 10.3284 19 9.5C19 8.67157 18.3284 8 17.5 8ZM14 9.5C14 7.567 15.567 6 17.5 6C19.433 6 21 7.567 21 9.5C21 11.433 19.433 13 17.5 13C15.567 13 14 11.433 14 9.5Z"
        fill="#F2994A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.5 2C8.67157 2 8 2.67157 8 3.5C8 4.32843 8.67157 5 9.5 5C10.3284 5 11 4.32843 11 3.5C11 2.67157 10.3284 2 9.5 2ZM6 3.5C6 1.567 7.567 0 9.5 0C11.433 0 13 1.567 13 3.5C13 5.433 11.433 7 9.5 7C7.567 7 6 5.433 6 3.5Z"
        fill="#F2994A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 11.4477 0.447715 11 1 11H2C2.65081 11 3.72806 11.124 4.80242 11.4598C5.70034 11.7404 6.73139 12.2106 7.4719 13H10C11.6357 13 13.088 13.7856 14.0003 15H19C20.6777 15 21.7302 15.6124 22.3389 16.3773C22.6272 16.7397 22.7883 17.1021 22.8781 17.3773C22.9232 17.5156 22.9513 17.6348 22.9687 17.7254C22.9774 17.7709 22.9835 17.8096 22.9878 17.8404C22.9899 17.8558 22.9916 17.8693 22.9929 17.8808L22.9946 17.8964L22.9953 17.903L22.9956 17.9061L22.9957 17.9075C22.9958 17.9082 22.9958 17.9089 22 18L22.9958 17.9089C23.0366 18.3544 22.7765 18.7728 22.359 18.9333L10.5943 23.4582C10.5942 23.4583 10.5944 23.4582 10.5943 23.4582C9.54446 23.8623 8.37357 23.8048 7.36879 23.3024L0.552786 19.8944C0.214002 19.725 0 19.3788 0 19V12ZM20.6183 17.46C20.3693 17.2423 19.9009 17 19 17H14.9C14.9656 17.3231 15 17.6575 15 18C15 18.5523 14.5523 19 14 19H7C6.44772 19 6 18.5523 6 18C6 17.4477 6.44772 17 7 17H12.8293C12.4174 15.8349 11.3061 15 10 15H7C6.67378 15 6.36806 14.8409 6.18092 14.5737C5.82377 14.0637 5.10703 13.6504 4.20583 13.3687C3.32994 13.095 2.45419 13 2 13V18.382L8.26321 21.5136C8.76633 21.7651 9.35162 21.7936 9.8757 21.5918L20.6183 17.46Z"
        fill="#F2994A"
      />
    </svg>
  ),
  "send-message": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7071 2.29289C22.0976 2.68342 22.0976 3.31658 21.7071 3.70711L10.7071 14.7071C10.3166 15.0976 9.68342 15.0976 9.29289 14.7071C8.90237 14.3166 8.90237 13.6834 9.29289 13.2929L20.2929 2.29289C20.6834 1.90237 21.3166 1.90237 21.7071 2.29289Z"
        fill="#2F80ED"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7071 2.29292C21.9829 2.56873 22.0732 2.97973 21.9384 3.34573L14.9384 22.3457C14.8005 22.7199 14.4535 22.9764 14.0553 22.9985C13.6571 23.0206 13.2839 22.8039 13.1056 22.4472L9.25465 14.7454L1.55279 10.8945C1.19611 10.7161 0.979485 10.3429 1.00154 9.94473C1.02359 9.54656 1.28011 9.19955 1.6543 9.06169L20.6543 2.06169C21.0203 1.92684 21.4313 2.01711 21.7071 2.29292ZM4.51462 10.1393L10.4472 13.1056C10.6407 13.2024 10.7977 13.3593 10.8944 13.5528L13.8607 19.4854L19.3126 4.6874L4.51462 10.1393Z"
        fill="#2F80ED"
      />
    </svg>
  ),
  "warning-usb": (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.9997 39.966L85.0997 83.3327H34.8997L59.9997 39.966ZM59.9997 26.666L23.333 89.9993H96.6663L59.9997 26.666ZM63.333 73.3327H56.6663V79.9993H63.333V73.3327ZM63.333 53.3327H56.6663V66.666H63.333V53.3327Z"
        fill="#F57C00"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#F57C00" strokeDasharray="5 5" />
    </svg>
  ),
  "warning-usb2": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
    >
      <path
        d="M56.666 69.9998H63.3327V76.6665H56.666V69.9998ZM56.666 43.3332H63.3327V63.3332H56.666V43.3332ZM59.966 26.6665C41.566 26.6665 26.666 41.5998 26.666 59.9998C26.666 78.3998 41.566 93.3332 59.966 93.3332C78.3994 93.3332 93.3327 78.3998 93.3327 59.9998C93.3327 41.5998 78.3994 26.6665 59.966 26.6665ZM59.9994 86.6665C45.266 86.6665 33.3327 74.7332 33.3327 59.9998C33.3327 45.2665 45.266 33.3332 59.9994 33.3332C74.7327 33.3332 86.666 45.2665 86.666 59.9998C86.666 74.7332 74.7327 86.6665 59.9994 86.6665Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  "not-cks": (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M56.667 69.9994H63.3337V76.666H56.667V69.9994ZM56.667 43.3327H63.3337V63.3327H56.667V43.3327ZM59.967 26.666C41.567 26.666 26.667 41.5993 26.667 59.9994C26.667 78.3994 41.567 93.3327 59.967 93.3327C78.4003 93.3327 93.3337 78.3994 93.3337 59.9994C93.3337 41.5993 78.4003 26.666 59.967 26.666ZM60.0003 86.666C45.267 86.666 33.3337 74.7327 33.3337 59.9994C33.3337 45.266 45.267 33.3327 60.0003 33.3327C74.7337 33.3327 86.667 45.266 86.667 59.9994C86.667 74.7327 74.7337 86.666 60.0003 86.666Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  "d-check": (
    <svg
      width="30px"
      height="30px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.7071 7.29289C19.0976 7.68342 19.0976 8.31658 18.7071 8.70711L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071L5.29289 12.7071C4.90237 12.3166 4.90237 11.6834 5.29289 11.2929C5.68342 10.9024 6.31658 10.9024 6.70711 11.2929L10 14.5858L17.2929 7.29289C17.6834 6.90237 18.3166 6.90237 18.7071 7.29289Z"
        fill="#868E96"
      />
    </svg>
  ),
  bin: (
    <svg
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z"
        fill="#FF6569"
      />
    </svg>
  ),
  hierarchy: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 9V15"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 15V12H21V15"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 23C4.10457 23 5 22.1046 5 21C5 19.8954 4.10457 19 3 19C1.89543 19 1 19.8954 1 21C1 22.1046 1.89543 23 3 23Z"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M12 23C13.1046 23 14 22.1046 14 21C14 19.8954 13.1046 19 12 19C10.8954 19 10 19.8954 10 21C10 22.1046 10.8954 23 12 23Z"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 23C22.1046 23 23 22.1046 23 21C23 19.8954 22.1046 19 21 19C19.8954 19 19 19.8954 19 21C19 22.1046 19.8954 23 21 23Z"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M14 1H10V5H14V1Z"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  settings: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M14 19L16.95 21.95C17.2759 22.2826 17.6648 22.5468 18.0941 22.7272C18.5234 22.9076 18.9844 23.0005 19.45 23.0005C19.9156 23.0005 20.3766 22.9076 20.8059 22.7272C21.2352 22.5468 21.6241 22.2826 21.95 21.95V21.95C22.2826 21.6241 22.5468 21.2352 22.7272 20.8059C22.9076 20.3766 23.0005 19.9156 23.0005 19.45C23.0005 18.9844 22.9076 18.5234 22.7272 18.0941C22.5468 17.6648 22.2826 17.2759 21.95 16.95L20 15"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.925 10.225L6.5 6.79999"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.4001 7.49999L6.5001 6.79999L7.2001 4.69999L4.4001 1.89999L1.6001 4.69999L4.4001 7.49999Z"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.6781 4.92199L19.6001 7.98699L16.0051 4.41098L19.0851 1.34499C18.3746 1.03694 17.593 0.930716 16.8261 1.03799C15.4031 1.16021 14.0802 1.82008 13.1266 2.8833C12.173 3.94651 11.6604 5.33315 11.6931 6.76099C11.6855 7.32229 11.7899 7.87946 12.0001 8.39998L2.14506 17.083C1.80331 17.3877 1.52625 17.758 1.33032 18.1718C1.13438 18.5856 1.02357 19.0346 1.00445 19.4921C0.985327 19.9496 1.05829 20.4062 1.21901 20.835C1.37973 21.2637 1.62493 21.6558 1.94006 21.988V21.988C2.26247 22.3252 2.65296 22.5899 3.08559 22.7646C3.51822 22.9392 3.98307 23.0197 4.44923 23.0008C4.91538 22.9819 5.37218 22.864 5.78923 22.6548C6.20628 22.4457 6.57405 22.1502 6.86806 21.788L15.5941 11.978C16.5267 12.2515 17.5075 12.3198 18.4691 12.178C19.4823 11.9687 20.4192 11.4869 21.1789 10.7845C21.9385 10.0821 22.4921 9.18573 22.7801 8.19199C23.1074 7.12053 23.0715 5.97096 22.6781 4.92199V4.92199Z"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.6723 4.9334C22.9946 5.64627 23.1056 6.43052 22.9933 7.19995C22.8651 8.62761 22.1742 9.95481 21.0612 10.9114"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  database: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4V20C3 21.7 7 23 12 23C17 23 21 21.7 21 20V4"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12 7C16.9706 7 21 5.65685 21 4C21 2.34315 16.9706 1 12 1C7.02944 1 3 2.34315 3 4C3 5.65685 7.02944 7 12 7Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 12C21 13.7 17 15 12 15C7 15 3 13.7 3 12"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  chart: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33329 7.66797H5.49996C6.14163 7.66797 6.66663 8.19297 6.66663 8.83464V14.668C6.66663 15.3096 6.14163 15.8346 5.49996 15.8346H5.33329C4.69163 15.8346 4.16663 15.3096 4.16663 14.668V8.83464C4.16663 8.19297 4.69163 7.66797 5.33329 7.66797ZM9.99996 4.16797C10.6416 4.16797 11.1666 4.69297 11.1666 5.33464V14.668C11.1666 15.3096 10.6416 15.8346 9.99996 15.8346C9.35829 15.8346 8.83329 15.3096 8.83329 14.668V5.33464C8.83329 4.69297 9.35829 4.16797 9.99996 4.16797ZM14.6666 10.8346C15.3083 10.8346 15.8333 11.3596 15.8333 12.0013V14.668C15.8333 15.3096 15.3083 15.8346 14.6666 15.8346C14.025 15.8346 13.5 15.3096 13.5 14.668V12.0013C13.5 11.3596 14.025 10.8346 14.6666 10.8346Z"
        fill="#212529"
      />
    </svg>
  ),
  notes: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 4C1 3.44772 1.44772 3 2 3H4C4.55228 3 5 3.44772 5 4C5 4.55228 4.55228 5 4 5H3V22H21V5H20C19.4477 5 19 4.55228 19 4C19 3.44772 19.4477 3 20 3H22C22.5523 3 23 3.44772 23 4V23C23 23.5523 22.5523 24 22 24H2C1.44772 24 1 23.5523 1 23V4Z"
        fill="#868E96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.1706 2C9.58229 0.834621 10.6934 0 12 0C13.3066 0 14.4177 0.834621 14.8294 2H17C17.5523 2 18 2.44772 18 3V7C18 7.55228 17.5523 8 17 8H7C6.44772 8 6 7.55228 6 7V3C6 2.44772 6.44772 2 7 2H9.1706ZM12 2C11.4473 2 11 2.44728 11 3C11 3.55228 10.5523 4 10 4H8V6H16V4H14C13.4477 4 13 3.55228 13 3C13 2.44728 12.5527 2 12 2Z"
        fill="#868E96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 11C6 10.4477 6.44772 10 7 10H17C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12H7C6.44772 12 6 11.5523 6 11Z"
        fill="#868E96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 15C6 14.4477 6.44772 14 7 14H17C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16H7C6.44772 16 6 15.5523 6 15Z"
        fill="#868E96"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 19C6 18.4477 6.44772 18 7 18H11C11.5523 18 12 18.4477 12 19C12 19.5523 11.5523 20 11 20H7C6.44772 20 6 19.5523 6 19Z"
        fill="#868E96"
      />
    </svg>
  ),
  add: (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M8 1.83398V15.1673"
          stroke={"white"}
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.6663 8.5H1.33301"
          stroke={"white"}
          strokeWidth="1.3"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  search: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
        fill={"#222D4B"}
      />
    </svg>
  ),
  arrowDown: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 4.5L8 12L0.5 4.5"
        stroke="#868E96"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "arrow-menu": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 4.6665H4.66682C4.42482 4.6665 4.20148 4.79784 4.08348 5.00984C3.96615 5.22184 3.97282 5.48117 4.10148 5.6865L7.43482 11.0198C7.55682 11.2145 7.77015 11.3332 8.00015 11.3332C8.23015 11.3332 8.44348 11.2145 8.56548 11.0198L11.8988 5.6865C12.0275 5.48117 12.0341 5.22184 11.9168 5.00984C11.7988 4.79784 11.5755 4.6665 11.3335 4.6665Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  trashCan: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.1" cx="24" cy="24" r="24" fill="#BC2618" />
      <path
        d="M32.25 16.5V33.5455C32.25 34.4868 31.5784 35.25 30.75 35.25H17.25C16.4216 35.25 15.75 34.4868 15.75 33.5455V16.5"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 22.125V30.375"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.25 22.125V30.375"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.75 22.125V30.375"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.25 16.5V12.75H27.75V16.5"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5 16.5H13.5"
        stroke="#B20D0D"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id="clip0">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  threeDots: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M3 14C4.10457 14 5 13.1046 5 12C5 10.8954 4.10457 10 3 10C1.89543 10 1 10.8954 1 12C1 13.1046 1.89543 14 3 14Z"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 14C22.1046 14 23 13.1046 23 12C23 10.8954 22.1046 10 21 10C19.8954 10 19 10.8954 19 12C19 13.1046 19.8954 14 21 14Z"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  dot: (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="4" cy="4" r="4" fill={"rgba(0, 0, 0, 0.5)"} />
    </svg>
  ),
  stationery: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1001 4.40002H20.5001"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M17.1001 10H20.5001"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M19 7.19995H20.5"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M5.8001 13.2L2.1001 7.40002L2.4001 2.40002L7.1001 4.40002L12.7001 13.3"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.2002 13V1H20.5002V13"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M20 13.5H22V23H2V13.5H20Z"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  menu: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z"
        fill="#222D4B"
      />
    </svg>
  ),
  meeting: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.992 18.7373L8.2 20.4003C8.704 20.7783 9 21.3703 9 22.0003V23.0003H1V22.0003C1 21.3703 1.296 20.7783 1.8 20.4003L4.008 18.7373"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.992 5.7373L15.2 7.4003C15.704 7.7783 16 8.3703 16 9.0003V10.0003H8V9.0003C8 8.3703 8.296 7.7783 8.8 7.4003L11.008 5.7373"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.992 18.7373L22.2 20.4003C22.704 20.7783 23 21.3703 23 22.0003V23.0003H15V22.0003C15 21.3703 15.296 20.7783 15.8 20.4003L18.008 18.7373"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
        stroke="#BB6BD9"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "access-key": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M11.2424 21.2426C13.5856 18.8995 13.5856 15.1005 11.2424 12.7574C8.89932 10.4143 5.10037 10.4143 2.75725 12.7574C0.414125 15.1005 0.414125 18.8995 2.75725 21.2426C5.10037 23.5857 8.89932 23.5857 11.2424 21.2426Z"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2432 12.757L22.0002 2"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 5L22 8L19 11L16 8"
          stroke="#F2994A"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "access-key-gray": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M11.2424 21.2426C13.5856 18.8995 13.5856 15.1005 11.2424 12.7574C8.89932 10.4143 5.10037 10.4143 2.75725 12.7574C0.414125 15.1005 0.414125 18.8995 2.75725 21.2426C5.10037 23.5857 8.89932 23.5857 11.2424 21.2426Z"
          stroke="#333"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.2432 12.757L22.0002 2"
          stroke="#333"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 5L22 8L19 11L16 8"
          stroke="#333"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "close-icon": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="12" fill="#CED4DA" />
      <path
        d="M16.6663 7.33337L7.33301 16.6667"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6663 16.6667L7.33301 7.33337"
        stroke="#868E96"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "filter-remove": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9H23"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 3H23"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 15H11"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M1 21H11"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M16 15L22 21"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M22 15L16 21"
        stroke="#EB5757"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  check: (
    <svg
      width="14"
      height="10"
      viewBox="0 0 14 10"
      fill="none"
      xmlns="hjustice://www.w3.org/2000/svg"
    >
      <path
        d="M1 5L5 9L13 1"
        stroke="#1574F6"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "role-group": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 4V20C3 21.7 7 23 12 23C17 23 21 21.7 21 20V4"
        stroke="#56CCF2"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M12 7C16.9706 7 21 5.65685 21 4C21 2.34315 16.9706 1 12 1C7.02944 1 3 2.34315 3 4C3 5.65685 7.02944 7 12 7Z"
        stroke="#56CCF2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M21 12C21 13.7 17 15 12 15C7 15 3 13.7 3 12"
        stroke="#56CCF2"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  authorization: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.992 18.7371L8.2 20.4001C8.704 20.7781 9 21.3701 9 22.0001V23.0001H1V22.0001C1 21.3701 1.296 20.7781 1.8 20.4001L4.008 18.7371"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5 19C3.895 19 3 18.105 3 17V16C3 14.895 3.895 14 5 14C6.105 14 7 14.895 7 16V17C7 18.105 6.105 19 5 19Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.992 5.73706L15.2 7.40006C15.704 7.77806 16 8.37006 16 9.00006V10.0001H8V9.00006C8 8.37006 8.296 7.77806 8.8 7.40006L11.008 5.73706"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 6C10.895 6 10 5.105 10 4V3C10 1.895 10.895 1 12 1C13.105 1 14 1.895 14 3V4C14 5.105 13.105 6 12 6Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.992 18.7371L22.2 20.4001C22.704 20.7781 23 21.3701 23 22.0001V23.0001H15V22.0001C15 21.3701 15.296 20.7781 15.8 20.4001L18.008 18.7371"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 19C17.895 19 17 18.105 17 17V16C17 14.895 17.895 14 19 14C20.105 14 21 14.895 21 16V17C21 18.105 20.105 19 19 19Z"
        stroke="#F2994A"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "notice-error": (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 28H30.6668L16.0002 2.66666L1.3335 28ZM5.96016 25.3333L16.0002 7.98666L26.0402 25.3333H5.96016ZM14.6668 21.3333H17.3335V24H14.6668V21.3333ZM14.6668 13.3333H17.3335V18.6667H14.6668V13.3333Z"
        fill="#E13F3D"
      />
    </svg>
  ),
  "notice-success": (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.6861 14.1597C28.0165 15.7411 28.1152 17.4848 27.8027 19.2574C26.5524 26.348 19.8333 31.0528 12.7427 29.8025C5.65211 28.5522 0.947385 21.8332 2.19765 14.7426C3.44792 7.65195 10.167 2.94722 17.2576 4.19749C19.7196 4.63161 21.9616 5.73773 23.7055 7.36528"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M10 16L15 21L30 6"
        stroke="#27AE60"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "icon-arrow-down": (
    <svg
      width="12"
      height="10"
      viewBox="0 0 12 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0L0.999979 0C0.636979 0 0.301979 0.197 0.124979 0.515C-0.0510214 0.833 -0.0410214 1.222 0.151979 1.53L5.15198 9.53C5.33498 9.822 5.65498 10 5.99998 10C6.34498 10 6.66498 9.822 6.84798 9.53L11.848 1.53C12.041 1.222 12.051 0.833 11.875 0.515C11.698 0.197 11.363 0 11 0Z"
        fill="#868E96"
      />
    </svg>
  ),
  faq: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16H11V14H9V16ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18ZM10 4C7.79 4 6 5.79 6 8H8C8 6.9 8.9 6 10 6C11.1 6 12 6.9 12 8C12 10 9 9.75 9 13H11C11 10.75 14 10.5 14 8C14 5.79 12.21 4 10 4Z"
        fill="#1574F6"
      />
    </svg>
  ),
  warning: (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33331 28H30.6666L16 2.66663L1.33331 28ZM17.3333 24H14.6666V21.3333H17.3333V24ZM17.3333 18.6666H14.6666V13.3333H17.3333V18.6666Z"
        fill="#E65100"
      />
    </svg>
  ),
  t_warning_default: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="hjustice://www.w3.org/2000/svg"
    >
      <path
        d="M2 22L12 3L22 22H2Z"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M12 11V15"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17C11.4477 17 11 17.4477 11 18C11 18.5523 11.4477 19 12 19Z"
        fill="#F57C00"
      />
    </svg>
  ),
  arrow_down: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 4.66669L4.66682 4.66669C4.42482 4.66669 4.20148 4.79802 4.08348 5.01002C3.96615 5.22202 3.97282 5.48135 4.10148 5.68669L7.43482 11.02C7.55682 11.2147 7.77015 11.3334 8.00015 11.3334C8.23015 11.3334 8.44348 11.2147 8.56548 11.02L11.8988 5.68669C12.0275 5.48135 12.0341 5.22202 11.9168 5.01002C11.7988 4.79802 11.5755 4.66669 11.3335 4.66669Z"
        fill="#868E96"
      />
    </svg>
  ),
  arrow_down_white: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3335 4.66666L4.66682 4.66666C4.42482 4.66666 4.20148 4.79799 4.08348 5.00999C3.96615 5.22199 3.97282 5.48132 4.10148 5.68666L7.43482 11.02C7.55682 11.2147 7.77015 11.3333 8.00015 11.3333C8.23015 11.3333 8.44348 11.2147 8.56548 11.02L11.8988 5.68666C12.0275 5.48132 12.0341 5.22199 11.9168 5.00999C11.7988 4.79799 11.5755 4.66666 11.3335 4.66666Z"
        fill="white"
      />
    </svg>
  ),
  process_group: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path d="M20 6H10V8H20V6Z" fill="#F2994A" />
        <path
          d="M2.26668 21.1875V2.81249C2.26668 2.29554 2.77506 1.87499 3.39998 1.87499H19.6001C20.225 1.87499 20.7334 2.29554 20.7334 2.81249V10.0683L23 12V2.81249C23 1.26168 21.4748 0 19.6001 0H3.39998C1.52526 0 0 1.26168 0 2.81249V21.1875C0 22.7383 1.5252 24 3.39993 24H10L10.5 22.125H3.39998C2.77506 22.125 2.26668 21.7045 2.26668 21.1875Z"
          fill="#F2994A"
        />
        <path d="M20 11H10V13H18L20 11Z" fill="#F2994A" />
        <path
          d="M20.117 12L13.8232 18.4717C13.4635 18.8328 13.1888 19.2791 13.0285 19.7629L13.0143 19.8058L12 24L16.4723 23.265L16.5165 23.2503C17.0027 23.0894 17.4512 22.8131 17.8134 22.451L24.1063 15.9804L20.117 12ZM16.4851 21.1301C16.45 21.1648 16.413 21.1976 16.3745 21.2284L15.0515 19.9045C15.0832 19.8651 15.117 19.8273 15.1527 19.7916L20.137 14.6665L21.4738 16.0003L16.4851 21.1301Z"
          fill="#F2994A"
        />
        <path
          d="M8.48433 9.40326L6.19176 12.0036L5.05096 10.9323L3.76855 12.298L6.31856 14.6926L9.8896 10.6423L8.48433 9.40326Z"
          fill="#F2994A"
        />
        <path
          d="M8.48433 3.73624L6.19176 6.33654L5.05096 5.26526L3.76855 6.63097L6.31856 9.02554L9.8896 4.97519L8.48433 3.73624Z"
          fill="#F2994A"
        />
        <path
          d="M5.05096 16.5526L3.76855 17.9183L6.31856 20.3129L9.8896 16.2626L8.48433 15.0236L6.19176 17.6239L5.05096 16.5526Z"
          fill="#F2994A"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "menu-log-work": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.42857 19V20.5C7.42857 22.75 5 23 5 23C5 23 19.4053 23 19.5714 23C20.913 23 22 21.881 22 20.5V19H7.42857Z"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 1H2V20.5C2 21.881 3.119 23 4.5 23H6"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 15C19.7614 15 22 12.7614 22 10C22 7.23858 19.7614 5 17 5C14.2386 5 12 7.23858 12 10C12 12.7614 14.2386 15 17 15Z"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17 8V10H19"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 6H9"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 10H9"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 14H9"
        stroke="#FF5722"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "menu-product": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.66732 13.3327H13.334V14.9993H6.66732V13.3327ZM6.66732 9.99935H13.334V11.666H6.66732V9.99935ZM11.6673 1.66602H5.00065C4.08398 1.66602 3.33398 2.41602 3.33398 3.33268V16.666C3.33398 17.5827 4.07565 18.3327 4.99232 18.3327H15.0007C15.9173 18.3327 16.6673 17.5827 16.6673 16.666V6.66602L11.6673 1.66602ZM15.0007 16.666H5.00065V3.33268H10.834V7.49935H15.0007V16.666Z"
        fill="#212529"
      />
    </svg>
  ),
  "menu-config": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13C9.176 13 6.671 13.638 5.025 14.193C3.81 14.604 3 15.749 3 17.032V21H12.5"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 13C13.824 13 16.329 13.638 17.975 14.193C19.19 14.604 20 15.749 20 17.032V21H12"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 13C9.239 13 7 9.761 7 7V6C7 3.239 9.239 1 12 1C14.761 1 17 3.239 17 6V7C17 9.761 14.761 13 12 13Z"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  ),
  "menu-role-group": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 5V1H16V5"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 15H1V5H23V15H15"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 18V23H2V18"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 13H9V17H15V13Z"
        stroke="#2196F3"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "menu-authori": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
    >
      <g clipPath="url(#clip0_709_17520)">
        <path
          d="M13.1828 4.95235C13.1828 7.67362 10.9511 9.89155 8.20611 9.89915C7.54622 9.90305 6.89208 9.77745 6.28147 9.5296C5.67087 9.28175 5.1159 8.91656 4.64862 8.45513C4.18134 7.99369 3.81101 7.44515 3.55901 6.84119C3.30702 6.23722 3.17835 5.58981 3.18045 4.93632C3.18045 2.21295 5.44106 -0.0151113 8.18865 7.71957e-05C9.51397 0.00130751 10.7846 0.523674 11.7211 1.45233C12.6576 2.38099 13.1834 3.63993 13.1828 4.95235ZM5.00265 4.94434C4.98902 6.66527 6.40862 8.0875 8.15541 8.10185C9.90221 8.11619 11.3469 6.71801 11.3644 4.99834C11.368 4.58463 11.2893 4.17428 11.1327 3.79071C10.9761 3.40713 10.7448 3.05785 10.4519 2.76281C10.159 2.46777 9.81034 2.23274 9.42573 2.07114C9.04113 1.90955 8.62815 1.82455 8.21037 1.821C7.7926 1.81746 7.37821 1.89543 6.99087 2.05048C6.60352 2.20552 6.25081 2.43459 5.95287 2.72462C5.65492 3.01465 5.41758 3.35995 5.2544 3.74081C5.09122 4.12167 5.00538 4.53063 5.0018 4.94434H5.00265Z"
          fill="#333"
        />
        <path
          d="M7.1014 11.25C8.05319 11.25 9.00455 11.25 9.95592 11.25C10.3521 11.25 10.6606 11.415 10.8242 11.7816C10.9784 12.1263 10.9294 12.4567 10.6781 12.7448C10.4855 12.9651 10.2329 13.0528 9.93845 13.0524C8.26266 13.0501 6.58687 13.051 4.91108 13.0549C4.35722 13.0549 3.80335 13.0731 3.29721 13.3503C2.44511 13.8186 1.9215 14.5122 1.85333 15.4918C1.81797 16.0032 1.82351 16.5175 1.81711 17.0301C1.8103 17.5959 1.44219 17.9962 0.916874 18.0005C0.378348 18.0038 -0.0165988 17.6043 1.70662e-05 17.0301C0.0217455 16.2795 0.00257337 15.5188 0.123571 14.7822C0.41371 13.0199 2.07573 11.4859 3.86726 11.3281C4.93962 11.234 6.02221 11.2517 7.10012 11.2192L7.1014 11.25Z"
          fill="#333"
        />
        <path
          d="M15.4685 14.908C15.5201 14.8595 15.5767 14.8084 15.6308 14.7549C16.565 13.83 17.4992 12.9055 18.4334 11.9813C18.7044 11.7138 19.0299 11.6281 19.3916 11.7547C19.7418 11.8775 19.9488 12.1344 19.9936 12.5036C20.0319 12.82 19.9033 13.074 19.6787 13.2955C18.5457 14.4119 17.4156 15.5302 16.2882 16.6505C16.2231 16.715 16.1604 16.7821 16.0918 16.8437C15.7084 17.1947 15.1814 17.1968 14.8086 16.8336C14.201 16.2429 13.5986 15.6462 13.0013 15.0434C12.6285 14.6675 12.6362 14.1127 13.0013 13.7579C13.3664 13.4031 13.9249 13.4204 14.3007 13.7874C14.6765 14.1545 15.045 14.522 15.4178 14.8886C15.4268 14.8975 15.443 14.8987 15.4685 14.908Z"
          fill="#333"
        />
      </g>
      <defs>
        <clipPath id="clip0_709_17520">
          <rect width="20" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "user-organ": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3806_31748)">
        <path
          d="M121.636 121.594C122.877 121.594 123.877 121.554 124.878 121.594C126.719 121.675 128 123.004 128 124.777C128 126.59 126.799 127.839 124.918 128C124.438 128.04 123.917 128.04 123.437 128.04C83.8124 128.04 44.1876 128.04 4.6029 128.04C4.04255 128.04 3.4822 128.04 2.96188 128C1.20078 127.799 0.0400519 126.55 2.68602e-05 124.898C-0.0399982 123.165 1.12073 121.755 2.88183 121.634C3.9625 121.554 5.0832 121.634 6.36401 121.634C6.36401 120.909 6.36401 120.264 6.36401 119.62C6.36401 88.194 6.36401 56.7681 6.36401 25.3422C6.36401 20.7895 8.04506 18.6945 12.3678 17.6872C37.3834 11.8855 62.399 6.08382 87.4147 0.282121C92.4578 -0.886277 96.02 1.93399 96.02 7.17164C96.02 10.838 96.0601 14.5043 95.98 18.211C95.94 19.3391 96.3002 19.9031 97.3008 20.3866C103.945 23.6501 110.509 27.0747 117.153 30.3381C120.275 31.8692 121.636 34.1657 121.596 37.6708C121.556 65.0275 121.556 92.3438 121.556 119.7C121.636 120.224 121.636 120.829 121.636 121.594ZM89.496 121.513C89.496 83.0772 89.496 44.8021 89.496 6.44643C89.1357 6.52701 88.8956 6.52701 88.6554 6.60758C63.92 12.369 39.2245 18.0901 14.4891 23.8112C13.0882 24.1336 12.688 24.6573 12.728 26.0674C12.768 57.2919 12.768 88.5163 12.768 119.7C12.768 120.305 12.768 120.869 12.768 121.473C21.4134 121.473 29.8587 121.473 38.424 121.473C38.424 120.869 38.424 120.305 38.424 119.781C38.424 116.074 38.384 112.327 38.4641 108.621C38.5441 104.954 41.2258 102.295 44.9081 102.255C49.1508 102.215 53.3934 102.215 57.6761 102.255C61.2783 102.295 64 105.035 64.0401 108.701C64.0801 112.489 64.0401 116.236 64.0401 120.023C64.0401 120.506 64.0801 120.99 64.1201 121.513C72.5654 121.513 80.9706 121.513 89.496 121.513ZM96.1401 26.9538C96.1401 58.6214 96.1401 90.0473 96.1401 121.513C102.544 121.513 108.788 121.513 115.232 121.513C115.232 120.788 115.232 120.144 115.232 119.499C115.232 93.4719 115.152 67.4448 115.352 41.4178C115.392 37.7514 114.512 35.7772 111.069 34.3268C106.026 32.2318 101.223 29.4921 96.1401 26.9538ZM44.8681 108.742C44.8681 113.093 44.8681 117.323 44.8681 121.473C49.1508 121.473 53.3134 121.473 57.476 121.473C57.476 117.162 57.476 112.972 57.476 108.742C53.2333 108.742 49.1107 108.742 44.8681 108.742Z"
          fill="#262626"
        />
        <path
          d="M31.9368 44.9903C30.9691 44.9903 29.9641 45.0122 28.9963 44.9903C27.2469 44.9465 26.0931 44.2902 26.0558 43.2837C25.9814 42.1023 25.9814 40.9208 26.0558 39.7612C26.0931 38.7548 27.2469 38.0766 28.9591 38.0328C30.9691 37.9891 32.9418 37.9891 34.9518 38.0328C36.7012 38.0547 37.8179 38.6892 37.9295 39.7394C38.0412 40.9208 38.004 42.1023 37.9295 43.2619C37.8551 44.3339 36.7012 44.9465 34.8774 44.9903C33.9096 44.9903 32.9418 44.9903 31.9368 44.9903Z"
          fill="#262626"
        />
        <path
          d="M31.9368 63.9903C30.9691 63.9903 29.9641 64.0122 28.9963 63.9903C27.2469 63.9465 26.0931 63.2902 26.0558 62.2837C25.9814 61.1023 25.9814 59.9208 26.0558 58.7612C26.0931 57.7548 27.2469 57.0766 28.9591 57.0328C30.9691 56.9891 32.9418 56.9891 34.9518 57.0328C36.7012 57.0547 37.8179 57.6892 37.9295 58.7394C38.0412 59.9208 38.004 61.1023 37.9295 62.2619C37.8551 63.3339 36.7012 63.9465 34.8774 63.9903C33.9096 63.9903 32.9418 63.9903 31.9368 63.9903Z"
          fill="#262626"
        />
        <path
          d="M31.9368 82.9903C30.9691 82.9903 29.9641 83.0122 28.9963 82.9903C27.2469 82.9465 26.0931 82.2902 26.0558 81.2837C25.9814 80.1023 25.9814 78.9208 26.0558 77.7612C26.0931 76.7548 27.2469 76.0766 28.9591 76.0328C30.9691 75.9891 32.9418 75.9891 34.9518 76.0328C36.7012 76.0547 37.8179 76.6892 37.9295 77.7394C38.0412 78.9208 38.004 80.1023 37.9295 81.2619C37.8551 82.3339 36.7012 82.9465 34.8774 82.9903C33.9096 82.9903 32.9418 82.9903 31.9368 82.9903Z"
          fill="#262626"
        />
        <path
          d="M51.5325 38.0097C52.5437 38.0097 53.5549 37.9878 54.5662 38.0097C56.5482 38.0536 57.8425 38.6457 57.9234 39.7203C58.0448 40.9045 58.0043 42.0888 57.9234 43.2511C57.8425 44.3256 56.5886 44.9616 54.6066 44.9836C52.5033 45.0055 50.3595 45.0055 48.2561 44.9836C46.355 44.9616 45.1011 44.2818 45.0607 43.273C44.9798 42.0888 44.9798 40.9045 45.0607 39.7422C45.1011 38.7334 46.355 38.0755 48.2157 38.0097C49.3078 37.9878 50.4404 38.0317 51.5325 38.0097Z"
          fill="#262626"
        />
        <path
          d="M51.5325 57.0097C52.5437 57.0097 53.5549 56.9878 54.5662 57.0097C56.5482 57.0536 57.8425 57.6457 57.9234 58.7203C58.0448 59.9045 58.0043 61.0888 57.9234 62.2511C57.8425 63.3256 56.5886 63.9616 54.6066 63.9836C52.5033 64.0055 50.3595 64.0055 48.2561 63.9836C46.355 63.9616 45.1011 63.2818 45.0607 62.273C44.9798 61.0888 44.9798 59.9045 45.0607 58.7422C45.1011 57.7334 46.355 57.0755 48.2157 57.0097C49.3078 56.9878 50.4404 57.0317 51.5325 57.0097Z"
          fill="#262626"
        />
        <path
          d="M51.5325 76.0097C52.5437 76.0097 53.5549 75.9878 54.5662 76.0097C56.5482 76.0536 57.8425 76.6457 57.9234 77.7203C58.0448 78.9045 58.0043 80.0888 57.9234 81.2511C57.8425 82.3256 56.5886 82.9616 54.6066 82.9836C52.5033 83.0055 50.3595 83.0055 48.2561 82.9836C46.355 82.9616 45.1011 82.2818 45.0607 81.273C44.9798 80.0888 44.9798 78.9045 45.0607 77.7422C45.1011 76.7334 46.355 76.0755 48.2157 76.0097C49.3078 75.9878 50.4404 76.0317 51.5325 76.0097Z"
          fill="#262626"
        />
        <path
          d="M70.4444 44.9691C69.3535 44.9691 68.2222 44.9909 67.1313 44.9691C65.3535 44.9253 64.101 44.2689 64.0606 43.2842C63.9798 42.1027 63.9798 40.943 64.0606 39.7614C64.101 38.733 65.3535 38.0547 67.2121 38.0328C69.3939 37.9891 71.5354 37.9891 73.7172 38.0328C75.5758 38.0547 76.8283 38.6455 76.9091 39.6301C77.0303 40.8555 77.0303 42.1027 76.9091 43.328C76.8283 44.3564 75.5354 44.9472 73.6364 44.9909C72.5859 45.0128 71.4949 44.9909 70.4444 44.9691Z"
          fill="#262626"
        />
        <path
          d="M70.4444 63.9691C69.3535 63.9691 68.2222 63.9909 67.1313 63.9691C65.3535 63.9253 64.101 63.2689 64.0606 62.2842C63.9798 61.1027 63.9798 59.943 64.0606 58.7614C64.101 57.733 65.3535 57.0547 67.2121 57.0328C69.3939 56.9891 71.5354 56.9891 73.7172 57.0328C75.5758 57.0547 76.8283 57.6455 76.9091 58.6301C77.0303 59.8555 77.0303 61.1027 76.9091 62.328C76.8283 63.3564 75.5354 63.9472 73.6364 63.9909C72.5859 64.0128 71.4949 63.9909 70.4444 63.9691Z"
          fill="#262626"
        />
        <path
          d="M70.4444 82.9691C69.3535 82.9691 68.2222 82.9909 67.1313 82.9691C65.3535 82.9253 64.101 82.2689 64.0606 81.2842C63.9798 80.1027 63.9798 78.943 64.0606 77.7614C64.101 76.733 65.3535 76.0547 67.2121 76.0328C69.3939 75.9891 71.5354 75.9891 73.7172 76.0328C75.5758 76.0547 76.8283 76.6455 76.9091 77.6301C77.0303 78.8555 77.0303 80.1027 76.9091 81.328C76.8283 82.3564 75.5354 82.9472 73.6364 82.9909C72.5859 83.0128 71.4949 82.9909 70.4444 82.9691Z"
          fill="#262626"
        />
      </g>
      <defs>
        <clipPath id="clip0_3806_31748">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "user-representative": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3806_31759)">
        <path
          d="M0 127.953C1.54683 100.943 15.1782 82.1 40.7009 70.8686C28.9547 62.2827 22.8157 51.005 23.4924 36.757C24.0242 26.2218 28.5196 17.2646 36.7372 10.2102C53.8006 -4.50193 79.4683 -3.06321 94.3565 13.134C109.68 29.7954 108.085 56.2957 87.3474 70.915C112.773 82.1 126.453 100.943 128 128C123.94 128 120.169 128 116.737 128C115.819 123.173 115.432 118.347 113.885 113.798C107.698 95.3733 94.6465 83.8636 75.1178 79.1761C73.7644 78.8512 73.1843 79.1761 72.7976 80.4756C72.0242 82.9818 71.0574 85.3951 70.2357 87.9013C69.9456 88.8295 69.5589 89.2008 68.4955 89.2008C65.4985 89.1079 62.4532 89.1543 59.4562 89.2008C58.5378 89.2008 58.0544 88.9223 57.8127 88.0405C56.9909 85.4415 55.9275 82.8889 55.1057 80.2899C54.719 79.0833 54.139 78.8976 53.0272 79.1761C31.8066 84.4205 18.4169 97.1833 13.0514 117.558C12.1813 120.899 12.0363 124.426 11.5529 128C7.97583 127.953 4.20544 127.953 0 127.953ZM93.003 38.9847C93.003 23.53 80.0967 11.1384 63.9517 11.1384C47.9517 11.1384 34.997 23.53 34.997 38.8918C34.9486 54.3465 47.855 66.8309 63.9517 66.8309C80.0483 66.8309 93.003 54.4393 93.003 38.9847Z"
          fill="#262626"
        />
        <path
          d="M52.4473 127.954C54.3325 117.14 56.1693 106.465 58.0062 95.7911C58.0545 95.4662 58.1995 95.1413 58.2962 94.7236C62.1149 94.7236 65.9337 94.7236 69.8007 94.7236C71.7343 105.769 73.6195 116.815 75.553 127.954C67.8672 127.954 60.2297 127.954 52.4473 127.954Z"
          fill="#262626"
        />
      </g>
      <defs>
        <clipPath id="clip0_3806_31759">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "user-single": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 128 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3806_31762)">
        <path
          d="M62.9547 128C50.9426 127.795 38.6003 126.36 26.7946 121.807C21.676 119.839 16.8464 117.296 13.09 113.154C10.3244 110.119 8.92089 106.633 9.00344 102.531C9.37495 88.0949 14.5761 75.7091 24.6894 65.374C26.8358 63.2003 29.8079 63.0362 31.8719 64.9638C33.9771 66.9324 34.0183 69.9674 31.7893 72.223C24.9783 79.1542 20.8092 87.3566 19.3644 96.9536C19.1167 98.6351 19.1167 100.317 18.9103 101.998C18.6214 104.377 19.6946 106.14 21.3871 107.658C24.3591 110.283 27.9091 111.923 31.6242 113.236C40.8293 116.558 50.406 117.87 60.1478 118.116C72.1186 118.403 83.9656 117.378 95.3173 113.236C98.3719 112.128 101.303 110.488 104.11 108.847C107.206 107.002 108.403 104.254 108.072 100.522C107.04 89.6123 102.954 80.1385 95.1934 72.3051C93.9551 71.0747 93.1708 69.6803 93.3772 67.9167C93.6248 65.9071 94.6981 64.4717 96.5969 63.7745C98.5783 63.0362 100.353 63.5284 101.839 65.0048C107.783 70.8286 112.118 77.6367 114.883 85.4701C116.782 90.8427 117.69 96.3384 117.979 102.039C118.227 107.125 116.246 111.226 112.572 114.589C108.072 118.772 102.582 121.233 96.8033 123.12C86.0295 126.606 74.843 127.877 62.9547 128Z"
          fill="#262626"
        />
        <path
          d="M63.5744 8.1835e-05C82.8928 0.0410943 98.2072 15.5028 98.166 34.9427C98.1247 53.4804 82.3562 68.9421 63.4918 68.9011C44.2147 68.8601 28.7352 53.3573 28.8177 34.1635C28.9003 15.3388 44.5036 -0.0409307 63.5744 8.1835e-05ZM63.4506 59.0581C77.1964 59.0581 88.2178 48.0667 88.2591 34.4096C88.2591 20.8344 77.1138 9.84308 63.368 9.84308C49.8699 9.84308 38.7246 20.9575 38.7246 34.3275C38.7246 47.9847 49.8286 59.0581 63.4506 59.0581Z"
          fill="#262626"
        />
      </g>
      <defs>
        <clipPath id="clip0_3806_31762">
          <rect width="128" height="128" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "user-info-change": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3618_20188)">
        <path
          d="M17.5297 5.95054C17.5227 9.22263 14.9071 11.8799 11.6862 11.8728C8.45836 11.8728 5.83575 9.19436 5.84966 5.90814C5.85662 2.64312 8.48619 -0.00705304 11.7071 1.41015e-05C14.9279 0.00708124 17.5297 2.67139 17.5297 5.95054ZM15.8601 5.93641C15.8601 3.59012 13.9888 1.69613 11.6792 1.69613C9.39053 1.69613 7.51923 3.59719 7.51227 5.92228C7.50532 8.2615 9.37662 10.1696 11.6792 10.1767C13.9888 10.1767 15.8601 8.2827 15.8601 5.93641Z"
          fill="#333"
        />
        <path
          d="M1.61479 22.0493C1.80262 22.0493 1.90001 22.0493 2.00435 22.0493C5.20435 22.0493 8.40436 22.0493 11.6044 22.0493C12.14 22.0493 12.5157 22.3885 12.5226 22.8832C12.5296 23.3284 12.2026 23.703 11.7644 23.7454C11.6878 23.7525 11.6113 23.7525 11.5278 23.7525C8.02175 23.7525 4.52262 23.7525 1.01653 23.7525C0.306964 23.7454 -0.00607955 23.4345 0.000876974 22.7136C0.0078335 21.703 -0.0408622 20.6853 0.146964 19.6747C0.752181 16.4733 3.52783 13.8726 6.72783 13.6253C8.05653 13.5193 9.40609 13.5829 10.7417 13.5687C10.9504 13.5687 11.1591 13.5687 11.3678 13.5687C11.9244 13.5687 12.3 13.915 12.307 14.4097C12.307 14.9115 11.9313 15.2648 11.3817 15.2648C10.1017 15.2648 8.8287 15.2648 7.5487 15.2648C4.74522 15.2719 2.40783 17.1659 1.81653 19.9504C1.6774 20.6147 1.6774 21.3143 1.61479 22.0493Z"
          fill="#333"
        />
        <path
          d="M19.006 13.8243C21.7886 13.8384 24.0147 16.1211 24.0008 18.948C23.9869 21.7324 21.7121 24.0151 18.9782 23.9939C16.2026 23.9798 13.9695 21.6829 13.9904 18.8561C13.9973 16.0716 16.2512 13.8102 19.006 13.8243ZM18.9991 15.5204C17.1556 15.5133 15.653 17.0257 15.646 18.8914C15.6391 20.7642 17.1486 22.3048 18.9852 22.3048C20.8078 22.3048 22.3104 20.7854 22.3243 18.9409C22.3382 17.054 20.8565 15.5275 18.9991 15.5204Z"
          fill="#333"
        />
        <path
          d="M19.8182 19.9141C19.8182 20.2039 19.8252 20.4936 19.8182 20.7904C19.8043 21.271 19.4426 21.6314 18.9904 21.6314C18.5313 21.6314 18.1626 21.271 18.1556 20.7975C18.1487 20.218 18.1487 19.6314 18.1556 19.0519C18.1626 18.5714 18.5243 18.2109 18.9834 18.2109C19.4356 18.2109 19.8043 18.5714 19.8182 19.0449C19.8252 19.3275 19.8182 19.6173 19.8182 19.9141Z"
          fill="#333"
        />
        <path
          d="M18.9852 17.9782C18.526 17.9782 18.1573 17.6036 18.1504 17.1443C18.1504 16.6708 18.54 16.2821 18.9991 16.2892C19.4513 16.2962 19.82 16.6849 19.82 17.1443C19.82 17.6036 19.4443 17.9782 18.9852 17.9782Z"
          fill="#333"
        />
      </g>
      <defs>
        <clipPath id="clip0_3618_20188">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "filter-black": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M22 0H2C1.73478 0 1.48043 0.105357 1.29289 0.292893C1.10536 0.48043 1 0.734784 1 1V4C1.00006 4.26519 1.10545 4.51951 1.293 4.707L9 12.414V23C9 23.1857 9.05171 23.3678 9.14935 23.5257C9.24698 23.6837 9.38668 23.8114 9.55279 23.8944C9.71889 23.9775 9.90484 24.0126 10.0898 23.996C10.2748 23.9793 10.4514 23.9114 10.6 23.8L14.6 20.8C14.7242 20.7069 14.825 20.5861 14.8944 20.4472C14.9639 20.3084 15 20.1552 15 20V12.414L22.707 4.707C22.8946 4.51951 22.9999 4.26519 23 4V1C23 0.734784 22.8946 0.48043 22.7071 0.292893C22.5196 0.105357 22.2652 0 22 0V0Z"
          fill="#616161"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  confirm: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12L10 16L18 8"
        stroke="#18BC78"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  history: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 7V12L16 16"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C8.1 2 4.7 4.2 3.1 7.5"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.26392 2.56982L3.09992 7.49982L8.02992 6.66382"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "edit-course": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#00AEAC"
      />
    </svg>
  ),
  "edit-course-small": (
    <svg
      width="15"
      height="15"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#00AEAC"
      />
    </svg>
  ),
  edit: (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.71 5.03957L14.37 7.36957L10.62 3.61957L12.96 1.28957C13.35 0.89957 14 0.89957 14.37 1.28957L16.71 3.62957C17.1 3.99957 17.1 4.64957 16.71 5.03957ZM0 14.2496L10.06 4.17957L13.81 7.92957L3.75 17.9996H0V14.2496ZM13.62 2.03957L12.08 3.57957L14.42 5.91957L15.96 4.37957L13.62 2.03957ZM12.36 7.99957L10 5.63957L1 14.6596V16.9996H3.34L12.36 7.99957Z"
        fill="#219653"
      />
    </svg>
  ),
  "arrow-right": (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66699 4.66652L4.66699 11.3332C4.66699 11.5752 4.79833 11.7985 5.01033 11.9165C5.22233 12.0339 5.48166 12.0272 5.68699 11.8985L11.0203 8.56518C11.215 8.44318 11.3337 8.22985 11.3337 7.99985C11.3337 7.76985 11.215 7.55652 11.0203 7.43452L5.68699 4.10118C5.48166 3.97252 5.22233 3.96585 5.01033 4.08318C4.79833 4.20118 4.66699 4.42452 4.66699 4.66652Z"
        fill={"#616161"}
      />
    </svg>
  ),
  "arrow-down": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_82_19447)">
        <path d="M12 16L6 10L18 10L12 16Z" fill="#6A7688" />
      </g>
      <defs>
        <clipPath id="clip0_82_19447">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(24) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  calendar: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8333 3.33268H15V2.49935C15 2.04102 14.625 1.66602 14.1667 1.66602C13.7083 1.66602 13.3333 2.04102 13.3333 2.49935V3.33268H6.66667V2.49935C6.66667 2.04102 6.29167 1.66602 5.83333 1.66602C5.375 1.66602 5 2.04102 5 2.49935V3.33268H4.16667C3.24167 3.33268 2.50833 4.08268 2.50833 4.99935L2.5 16.666C2.5 17.5827 3.24167 18.3327 4.16667 18.3327H15.8333C16.75 18.3327 17.5 17.5827 17.5 16.666V4.99935C17.5 4.08268 16.75 3.33268 15.8333 3.33268ZM15.8333 15.8327C15.8333 16.291 15.4583 16.666 15 16.666H5C4.54167 16.666 4.16667 16.291 4.16667 15.8327V7.49935H15.8333V15.8327ZM5.83333 9.16602H7.5V10.8327H5.83333V9.16602ZM9.16667 9.16602H10.8333V10.8327H9.16667V9.16602ZM12.5 9.16602H14.1667V10.8327H12.5V9.16602Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  warning_default: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
        stroke="#18BC78"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33398V10.0007"
        stroke="#18BC78"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
        fill="#18BC78"
      />
    </svg>
  ),
  warning_green: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
        stroke="#18BC78"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33398V10.0007"
        stroke="#18BC78"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
        fill="#18BC78"
      />
    </svg>
  ),
  warning_yellow: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33301 14.6667L7.99967 2L14.6663 14.6667H1.33301Z"
        stroke="#F2994A"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33398V10.0007"
        stroke="#F2994A"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M7.99967 12.6673C8.36786 12.6673 8.66634 12.3688 8.66634 12.0007C8.66634 11.6325 8.36786 11.334 7.99967 11.334C7.63148 11.334 7.33301 11.6325 7.33301 12.0007C7.33301 12.3688 7.63148 12.6673 7.99967 12.6673Z"
        fill="#F2994A"
      />
    </svg>
  ),
  warning_red: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.3335 14.6667L8.00016 2L14.6668 14.6667H1.3335Z"
        stroke="#BC2618"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.33398V10.0007"
        stroke="#BC2618"
        strokeWidth="1.3"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.00016 12.6673C8.36835 12.6673 8.66683 12.3688 8.66683 12.0007C8.66683 11.6325 8.36835 11.334 8.00016 11.334C7.63197 11.334 7.3335 11.6325 7.3335 12.0007C7.3335 12.3688 7.63197 12.6673 8.00016 12.6673Z"
        fill="#BC2618"
      />
    </svg>
  ),
  "confirm-lw": (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle opacity="0.1" cx="24" cy="24" r="24" fill="#F57C00" />
      <path
        d="M14 32L24 13L34 32H14Z"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path
        d="M24 21V25"
        stroke="#F57C00"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M24 29C24.5523 29 25 28.5523 25 28C25 27.4477 24.5523 27 24 27C23.4477 27 23 27.4477 23 28C23 28.5523 23.4477 29 24 29Z"
        fill="#F57C00"
      />
    </svg>
  ),
  "file-text": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM10 9H18V11H10V9ZM10 12H14V14H10V12ZM10 6H18V8H10V6Z"
        fill={"rgba(0, 0, 0, 0.5)"}
      />
    </svg>
  ),
  folder: (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 2H10L8 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V4C20 2.9 19.1 2 18 2ZM18 14H2V4H18V14Z"
        fill="#212529"
      />
    </svg>
  ),
  document: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
    >
      <g clipPath="url(#clip0_530_10986)">
        <path
          d="M4.5 6C4.5 5.6 4.5 5.2 4.5 4.8C4.5 3 5.6 1.8 7.4 1.7C7.7 1.7 7.9 1.6 8.1 1.3C8.6 0.5 9.5 0 10.5 0C11.2 0 11.8 0 12.5 0C13.4 0.1 14.1 0.6 14.6 1.3C14.7 1.5 14.8 1.5 15 1.6C15.9 1.6 16.6 1.9 17.2 2.5C17.7 3.1 18 3.8 18 4.5C18 8 18 11.6 18 15.1C18 16.7 16.6 18 15.1 18C14.6 18 14.1 18 13.5 18C13.5 18.4 13.5 18.7 13.5 19.1C13.5 19.4 13.4 19.7 13.3 19.9C13 20.6 12.4 21 11.7 21C8.4 21 5.2 21 1.9 21C0.9 21 0 20.2 0 19.1C0 15.3 0 11.6 0 7.8C0 6.8 0.8 6 1.9 6C2.7 6 3.5 6 4.3 6C4.3 6 4.4 6 4.5 6ZM12 13.5C12 11.7 12 9.9 12 8C12 7.6 11.9 7.5 11.5 7.5C8.3 7.5 5.2 7.5 2 7.5C1.6 7.5 1.5 7.6 1.5 8C1.5 11.7 1.5 15.3 1.5 19C1.5 19.4 1.6 19.5 2 19.5C5.1 19.5 8.3 19.5 11.4 19.5C11.8 19.5 11.9 19.4 11.9 19C12 17.2 12 15.3 12 13.5ZM13.5 16.5C14 16.5 14.4 16.5 14.9 16.5C15.9 16.5 16.5 15.9 16.5 14.9C16.5 12.1 16.5 9.4 16.5 6.6C16.5 5.9 16.5 5.3 16.5 4.6C16.5 3.8 15.8 3.1 15 3.2C15 3.3 15 3.3 15 3.4C14.8 4.1 14.3 4.6 13.6 4.6C12.1 4.6 10.5 4.6 9 4.6C8.3 4.5 7.7 4 7.6 3.4C7.6 3.3 7.6 3.2 7.5 3.2C6.6 3.2 6 3.8 6 4.6C6 4.9 6 5.2 6 5.5C6 5.7 6 5.8 6 6C6.1 6 6.2 6 6.3 6C8 6 9.8 6 11.5 6C12.7 6 13.5 6.8 13.5 8C13.5 10.4 13.5 12.8 13.5 15.2C13.5 15.6 13.5 16.1 13.5 16.5ZM9 3C10.5 3 12 3 13.5 3C13.5 2.2 12.9 1.5 12.1 1.5C11.5 1.5 11 1.5 10.4 1.5C9.6 1.5 9 2.2 9 3Z"
          fill="black"
        />
        <path
          d="M7.8998 11.3C7.2998 11.3 6.6998 11.3 6.0998 11.3C5.5998 11.3 5.2998 11 5.2998 10.6C5.2998 10.2 5.5998 9.80005 6.0998 9.80005C7.2998 9.80005 8.4998 9.80005 9.6998 9.80005C10.1998 9.80005 10.4998 10.1 10.4998 10.5C10.4998 10.9 10.1998 11.3 9.6998 11.3C9.0998 11.3 8.4998 11.3 7.8998 11.3Z"
          fill="black"
        />
        <path
          d="M7.8998 14.3C7.2998 14.3 6.6998 14.3 6.0998 14.3C5.5998 14.3 5.2998 14 5.2998 13.6C5.2998 13.2 5.5998 12.8 6.0998 12.8C7.2998 12.8 8.4998 12.8 9.6998 12.8C10.1998 12.8 10.4998 13.1 10.4998 13.5C10.4998 13.9 10.1998 14.3 9.6998 14.3C9.0998 14.3 8.4998 14.3 7.8998 14.3Z"
          fill="black"
        />
        <path
          d="M7.8998 17.3C7.2998 17.3 6.6998 17.3 6.0998 17.3C5.5998 17.3 5.2998 17 5.2998 16.6C5.2998 16.2 5.5998 15.8 6.0998 15.8C7.2998 15.8 8.4998 15.8 9.6998 15.8C10.1998 15.8 10.4998 16.1 10.4998 16.5C10.4998 16.9 10.1998 17.3 9.6998 17.3C9.0998 17.3 8.4998 17.3 7.8998 17.3Z"
          fill="black"
        />
        <path
          d="M3.8 11.3C3.4 11.3 3 11 3 10.5C3 10.1 3.3 9.69997 3.8 9.79997C4.2 9.79997 4.5 10.1 4.5 10.6C4.5 10.9 4.2 11.3 3.8 11.3Z"
          fill="black"
        />
        <path
          d="M4.5 13.5C4.5 13.9 4.2 14.2 3.7 14.2C3.3 14.2 3 13.9 3 13.4C3 13 3.3 12.6 3.8 12.7C4.2 12.8 4.5 13.1 4.5 13.5Z"
          fill="black"
        />
        <path
          d="M3.8 17.3C3.4 17.3 3 17 3 16.5C3 16.1 3.3 15.7 3.8 15.7C4.2 15.7 4.5 16 4.5 16.5C4.5 16.9 4.2 17.3 3.8 17.3Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_530_10986">
          <rect width="18" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  report: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6501 4.2629L16.4635 4.3642C18.3408 4.59801 19.75 6.19359 19.75 8.08545V18.5749C19.75 20.4118 18.3817 21.961 16.5589 22.188C13.5313 22.5651 10.4687 22.5651 7.44107 22.188C5.61826 21.961 4.25 20.4118 4.25 18.5749V8.08545C4.25 6.19359 5.6592 4.59801 7.53655 4.3642L8.3499 4.2629C8.67208 3.10206 9.73654 2.25 11 2.25H13C14.2635 2.25 15.3279 3.10206 15.6501 4.2629ZM8.25 5.78693L7.72193 5.8527C6.59552 5.99299 5.75 6.95034 5.75 8.08545V18.5749C5.75 19.655 6.55458 20.566 7.62645 20.6995C10.5309 21.0612 13.4691 21.0612 16.3735 20.6995C17.4454 20.566 18.25 19.655 18.25 18.5749V8.08545C18.25 6.95034 17.4045 5.99299 16.2781 5.8527L15.75 5.78693V7C15.75 7.41421 15.4142 7.75 15 7.75H9C8.58579 7.75 8.25 7.41421 8.25 7V5.78693ZM9.75 5C9.75 4.30964 10.3096 3.75 11 3.75H13C13.6904 3.75 14.25 4.30964 14.25 5V6.25H9.75V5Z"
        fill="black"
      />
      <path
        d="M15.75 11.75C15.75 11.3358 15.4142 11 15 11H9C8.58579 11 8.25 11.3358 8.25 11.75C8.25 12.1642 8.58579 12.5 9 12.5H15C15.4142 12.5 15.75 12.1642 15.75 11.75Z"
        fill="black"
      />
      <path
        d="M14.75 14.75C14.75 14.3358 14.4142 14 14 14H9C8.58579 14 8.25 14.3358 8.25 14.75C8.25 15.1642 8.58579 15.5 9 15.5H14C14.4142 15.5 14.75 15.1642 14.75 14.75Z"
        fill="black"
      />
    </svg>
  ),
  people: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.67 13.1299C18.04 14.0599 19 15.3199 19 16.9999V19.9999H23V16.9999C23 14.8199 19.43 13.5299 16.67 13.1299Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
      <path
        d="M15 12C17.21 12 19 10.21 19 8C19 5.79 17.21 4 15 4C14.53 4 14.09 4.1 13.67 4.24C14.5 5.27 15 6.58 15 8C15 9.42 14.5 10.73 13.67 11.76C14.09 11.9 14.53 12 15 12Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
      <path
        d="M9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
      <path
        d="M9 13C6.33 13 1 14.34 1 17V20H17V17C17 14.34 11.67 13 9 13ZM15 18H3V17.01C3.2 16.29 6.3 15 9 15C11.7 15 14.8 16.29 15 17V18Z"
        fill="rgba(0, 0, 0, 0.5)"
      />
    </svg>
  ),
  "icon-confirm": (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.9994 26.6665C41.666 26.6665 26.666 41.6665 26.666 59.9998C26.666 78.3332 41.666 93.3332 59.9994 93.3332C78.3327 93.3332 93.3327 78.3332 93.3327 59.9998C93.3327 41.6665 78.3327 26.6665 59.9994 26.6665ZM59.9994 86.6665C45.2994 86.6665 33.3327 74.6998 33.3327 59.9998C33.3327 45.2998 45.2994 33.3332 59.9994 33.3332C74.6994 33.3332 86.666 45.2998 86.666 59.9998C86.666 74.6998 74.6994 86.6665 59.9994 86.6665ZM61.666 43.3332H56.666V63.3332L73.9994 73.9998L76.666 69.6665L61.666 60.6665V43.3332Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  download: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.71875 8.59473L10 11.8751L13.2812 8.59473"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3.125V11.8727"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#2260BD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "icon-system": (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8833 3.76654L16.2417 6.12487L13.8833 8.4832L11.525 6.12487L13.8833 3.76654ZM7.5 4.16654V7.49987H4.16667V4.16654H7.5ZM15.8333 12.4999V15.8332H12.5V12.4999H15.8333ZM7.5 12.4999V15.8332H4.16667V12.4999H7.5ZM13.8833 1.4082L9.16667 6.11654L13.8833 10.8332L18.6 6.11654L13.8833 1.4082ZM9.16667 2.49987H2.5V9.16654H9.16667V2.49987ZM17.5 10.8332H10.8333V17.4999H17.5V10.8332ZM9.16667 10.8332H2.5V17.4999H9.16667V10.8332Z"
        fill="#212529"
      />
    </svg>
  ),
  eye: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 4.37402C3.75 4.37402 1.25 9.99963 1.25 9.99963C1.25 9.99963 3.75 15.624 10 15.624C16.25 15.624 18.75 9.99963 18.75 9.99963C18.75 9.99963 16.25 4.37402 10 4.37402Z"
        stroke="#01638D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
        stroke="#01638D"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "download-grey": (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
        fill="#757575"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="16"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
          fill="white"
        />
      </mask>
    </svg>
  ),
  "warning-cancel": (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M83.3334 41.3666L78.6334 36.6666L60.0001 55.3L41.3667 36.6666L36.6667 41.3666L55.3001 60L36.6667 78.6333L41.3667 83.3333L60.0001 64.7L78.6334 83.3333L83.3334 78.6333L64.7001 60L83.3334 41.3666Z"
        fill="#E50500"
      />
      <circle cx="60" cy="60" r="59.5" stroke="#E50500" strokeDasharray="5 5" />
    </svg>
  ),
  sign_success: (
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="32" cy="32" r="32" fill="#373839" />
      <path
        d="M20 32L28 40L44 24"
        stroke="#18BC78"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  eye_orange: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10.4996C11.173 10.4996 10.5 11.1726 10.5 11.9996C10.5 12.8266 11.173 13.4996 12 13.4996C12.827 13.4996 13.5 12.8266 13.5 11.9996C13.5 11.1726 12.827 10.4996 12 10.4996ZM12 15.4996C10.07 15.4996 8.5 13.9296 8.5 11.9996C8.5 10.0696 10.07 8.49964 12 8.49964C13.93 8.49964 15.5 10.0696 15.5 11.9996C15.5 13.9296 13.93 15.4996 12 15.4996ZM21.868 11.5016C21.229 10.3896 17.706 4.81564 11.729 5.00264C6.202 5.14364 2.986 10.0136 2.132 11.5016C1.956 11.8106 1.956 12.1886 2.132 12.4976C2.762 13.5946 6.162 18.9996 12.025 18.9996C12.106 18.9996 12.188 18.9986 12.271 18.9966C17.798 18.8556 21.014 13.9856 21.868 12.4976C22.044 12.1886 22.044 11.8106 21.868 11.5016Z"
        fill="#F7941E"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="4"
        width="20"
        height="15"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 10.4996C11.173 10.4996 10.5 11.1726 10.5 11.9996C10.5 12.8266 11.173 13.4996 12 13.4996C12.827 13.4996 13.5 12.8266 13.5 11.9996C13.5 11.1726 12.827 10.4996 12 10.4996ZM12 15.4996C10.07 15.4996 8.5 13.9296 8.5 11.9996C8.5 10.0696 10.07 8.49964 12 8.49964C13.93 8.49964 15.5 10.0696 15.5 11.9996C15.5 13.9296 13.93 15.4996 12 15.4996ZM21.868 11.5016C21.229 10.3896 17.706 4.81564 11.729 5.00264C6.202 5.14364 2.986 10.0136 2.132 11.5016C1.956 11.8106 1.956 12.1886 2.132 12.4976C2.762 13.5946 6.162 18.9996 12.025 18.9996C12.106 18.9996 12.188 18.9986 12.271 18.9966C17.798 18.8556 21.014 13.9856 21.868 12.4976C22.044 12.1886 22.044 11.8106 21.868 11.5016Z"
          fill="white"
        />
      </mask>
    </svg>
  ),
  download_orange: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
        fill="#F7941E"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="3"
        width="16"
        height="17"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.0028 12.0759C11.001 12.0508 11 12.0255 11 12V4C11 3.448 11.447 3 12 3C12.553 3 13 3.448 13 4V11.9998L15.4 10.2C15.842 9.867 16.469 9.958 16.8 10.4C17.132 10.842 17.042 11.469 16.6 11.8L12.6 14.8C12.423 14.933 12.211 15 12 15C11.799 15 11.598 14.939 11.425 14.818L7.425 12.004C6.973 11.686 6.864 11.062 7.182 10.611C7.5 10.159 8.123 10.05 8.575 10.368L11.0028 12.0759ZM6 17V18H18V17C18 16.45 18.45 16 19 16C19.55 16 20 16.45 20 17V19C20 19.55 19.55 20 19 20H5C4.45 20 4 19.55 4 19V17C4 16.45 4.45 16 5 16C5.55 16 6 16.45 6 17Z"
          fill="white"
        />
      </mask>
    </svg>
  ),
  sign_in: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 14H10.375C10.1687 14 10 13.8313 10 13.625V12.375C10 12.1687 10.1687 12 10.375 12H13C13.5531 12 14 11.5531 14 11V5C14 4.44688 13.5531 4 13 4H10.375C10.1687 4 10 3.83125 10 3.625V2.375C10 2.16875 10.1687 2 10.375 2H13C14.6562 2 16 3.34375 16 5V11C16 12.6562 14.6562 14 13 14ZM11.5312 7.71875L6.28125 2.46875C5.8125 2 5 2.32812 5 3V6H0.75C0.334375 6 0 6.33437 0 6.75V9.75C0 10.1656 0.334375 10.5 0.75 10.5H5V13.5C5 14.1719 5.8125 14.5 6.28125 14.0312L11.5312 8.78125C11.8219 8.4875 11.8219 8.0125 11.5312 7.71875Z"
        fill="white"
      />
    </svg>
  ),
  user_login: (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 8C9.20938 8 11 6.20937 11 4C11 1.79063 9.20938 0 7 0C4.79063 0 3 1.79063 3 4C3 6.20937 4.79063 8 7 8ZM9.8 9H9.27812C8.58437 9.31875 7.8125 9.5 7 9.5C6.1875 9.5 5.41875 9.31875 4.72188 9H4.2C1.88125 9 0 10.8813 0 13.2V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V13.2C14 10.8813 12.1187 9 9.8 9Z"
        fill="#9A9A9A"
      />
    </svg>
  ),
  user_login2: (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 8C9.20938 8 11 6.20937 11 4C11 1.79063 9.20938 0 7 0C4.79063 0 3 1.79063 3 4C3 6.20937 4.79063 8 7 8ZM9.8 9H9.27812C8.58437 9.31875 7.8125 9.5 7 9.5C6.1875 9.5 5.41875 9.31875 4.72188 9H4.2C1.88125 9 0 10.8813 0 13.2V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V13.2C14 10.8813 12.1187 9 9.8 9Z"
        fill="#267dc4"
      />
    </svg>
  ),
  lock_login: (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 7H11.75V4.75C11.75 2.13125 9.61875 0 7 0C4.38125 0 2.25 2.13125 2.25 4.75V7H1.5C0.671875 7 0 7.67188 0 8.5V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V8.5C14 7.67188 13.3281 7 12.5 7ZM9.25 7H4.75V4.75C4.75 3.50938 5.75938 2.5 7 2.5C8.24063 2.5 9.25 3.50938 9.25 4.75V7Z"
        fill="#9E9E9E"
      />
    </svg>
  ),
  copy: (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0H2C0.9 0 0 0.9 0 2V16H2V2H14V0ZM13 4H6C4.9 4 4.01 4.9 4.01 6L4 20C4 21.1 4.89 22 5.99 22H17C18.1 22 19 21.1 19 20V10L13 4ZM6 20V6H12V11H17V20H6Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  "copy-small": (
    <svg
      width="12"
      height="15"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 0H2C0.9 0 0 0.9 0 2V16H2V2H14V0ZM13 4H6C4.9 4 4.01 4.9 4.01 6L4 20C4 21.1 4.89 22 5.99 22H17C18.1 22 19 21.1 19 20V10L13 4ZM6 20V6H12V11H17V20H6Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  addRowAbove: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33464 4.99935H1.66797V16.666C1.66797 17.5827 2.41797 18.3327 3.33464 18.3327H15.0013V16.666H3.33464V4.99935ZM16.668 1.66602H6.66797C5.7513 1.66602 5.0013 2.41602 5.0013 3.33268V13.3327C5.0013 14.2493 5.7513 14.9993 6.66797 14.9993H16.668C17.5846 14.9993 18.3346 14.2493 18.3346 13.3327V3.33268C18.3346 2.41602 17.5846 1.66602 16.668 1.66602ZM16.668 13.3327H6.66797V3.33268H16.668V13.3327ZM10.8346 12.4993H12.5013V9.16602H15.8346V7.49935H12.5013V4.16602H10.8346V7.49935H7.5013V9.16602H10.8346V12.4993Z"
        fill="#A8B1BD"
      />
    </svg>
  ),
  addRowBelow: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6654 15.0007H18.332L18.332 3.33398C18.332 2.41732 17.582 1.66732 16.6654 1.66732H4.9987V3.33398L16.6654 3.33398V15.0007ZM3.33203 18.334L13.332 18.334C14.2487 18.334 14.9987 17.584 14.9987 16.6673L14.9987 6.66732C14.9987 5.75065 14.2487 5.00065 13.332 5.00065L3.33203 5.00065C2.41536 5.00065 1.66536 5.75065 1.66536 6.66732V16.6673C1.66536 17.584 2.41536 18.334 3.33203 18.334ZM3.33203 6.66732L13.332 6.66732L13.332 16.6673H3.33203L3.33203 6.66732ZM9.16536 7.50065H7.4987V10.834L4.16536 10.834L4.16536 12.5007L7.4987 12.5007V15.834H9.16536V12.5007H12.4987V10.834H9.16536V7.50065Z"
        fill="#A8B1BD"
      />
    </svg>
  ),
  "return-warning": (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.146022 5.85717L5.14612 0.531204C5.21601 0.456674 5.30508 0.405896 5.40207 0.385289C5.49905 0.364683 5.5996 0.375175 5.69098 0.415438C5.78237 0.455701 5.8605 0.523926 5.91548 0.611486C5.97047 0.699047 5.99984 0.802008 5.99988 0.90735V3.59363C7.62117 3.74143 9.41183 4.58693 10.885 5.91775C12.6588 7.52087 13.7632 9.58667 13.995 11.7344C14.0132 11.9013 13.9814 12.0701 13.9042 12.2168C13.827 12.3634 13.7084 12.4803 13.5652 12.551C13.4221 12.6216 13.2616 12.6424 13.1067 12.6103C12.9518 12.5782 12.8104 12.4948 12.7025 12.3722C12.015 11.5926 9.5687 9.12731 5.99988 8.91028V11.5593C5.99984 11.6646 5.97047 11.7676 5.91548 11.8551C5.8605 11.9427 5.78237 12.0109 5.69098 12.0512C5.5996 12.0915 5.49905 12.1019 5.40207 12.0813C5.30508 12.0607 5.21601 12.01 5.14612 11.9354L0.146022 6.60946C0.0525141 6.50962 0 6.37434 0 6.23331C0 6.09228 0.0525141 5.95701 0.146022 5.85717ZM4.99987 10.2737V8.3637C4.99987 8.22245 5.05254 8.08698 5.14631 7.9871C5.24008 7.88721 5.36726 7.8311 5.49988 7.8311C7.25491 7.8311 8.96432 8.31909 10.5806 9.28243C11.4038 9.77523 12.1707 10.3677 12.8663 11.048C12.5038 9.46085 11.59 7.9516 10.2381 6.72996C8.78681 5.41911 7.01553 4.63552 5.49988 4.63552C5.36726 4.63552 5.24008 4.57941 5.14631 4.47953C5.05254 4.37965 4.99987 4.24418 4.99987 4.10293V2.19357L1.20667 6.23331L4.99987 10.2737Z"
        fill="#FE0000"
      />
    </svg>
  ),
  import: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.71875 6.40539L10 3.125L13.2812 6.40539"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 11.8749V3.1272"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.875 11.875V16.25C16.875 16.4158 16.8092 16.5747 16.6919 16.6919C16.5747 16.8092 16.4158 16.875 16.25 16.875H3.75C3.58424 16.875 3.42527 16.8092 3.30806 16.6919C3.19085 16.5747 3.125 16.4158 3.125 16.25V11.875"
        stroke="#0D99FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  "file-pdf": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 14 18"
      fill="none"
    >
      <g clipPath="url(#clip0_3453_74753)">
        <path
          d="M13.9368 16.2421C13.925 16.2876 13.9131 16.333 13.9013 16.3823C13.7788 16.7725 13.5379 17.1249 13.222 17.3976C12.9693 17.6174 12.6849 17.7803 12.365 17.8826C12.2268 17.9281 12.0846 17.9546 11.9385 17.9773C11.7252 18.0114 11.512 18.0038 11.2987 18.0038C8.37236 18.0038 5.44993 18.0038 2.52355 18.0038C2.45642 18.0038 2.38533 18.0076 2.31819 18C2.17207 17.9887 2.0299 17.9659 1.88378 17.9356C1.69817 17.8977 1.52045 17.8371 1.35063 17.7538C0.888575 17.5302 0.533145 17.1968 0.284344 16.7611C0.197461 16.6096 0.134274 16.4429 0.0868829 16.2724C0.0157969 16.0299 0 15.7837 0 15.5374C0 11.1804 0 6.82344 0 2.47025C0 2.31492 0 2.15958 0.0236953 2.00803C0.0513399 1.8186 0.106629 1.63674 0.185614 1.45868C0.335684 1.11391 0.552891 0.822178 0.845134 0.583492C1.0268 0.431945 1.23216 0.30313 1.45331 0.212201C2.09309 -0.053006 2.8158 0.0151902 3.49111 0.0151902C3.88604 0.0151902 4.28096 0.0151902 4.67588 0.0151902C4.68378 0.0151902 4.69168 0.0151902 4.69958 0.0151902C5.49337 0.0151902 6.28717 0.0151902 7.08096 0.0151902C7.58251 0.0151902 8.08011 0.0151902 8.58166 0.0151902C8.62116 0.0151902 8.66065 0.0189789 8.70014 0.0189789C8.70014 0.064443 8.70409 0.113696 8.70409 0.15916C8.70409 1.8186 8.70409 3.47804 8.70409 5.13748C8.70409 5.29282 8.68434 5.27766 8.85416 5.27766C10.4812 5.27766 12.1083 5.27766 13.7394 5.27766C13.8223 5.27766 13.9013 5.27387 13.9842 5.28903C13.9882 5.29661 13.9961 5.30039 14 5.30797C14 5.33449 13.996 5.35722 13.996 5.38374C13.996 5.64895 13.996 5.91037 13.996 6.17558C13.996 6.44078 13.996 6.70599 13.996 6.9712C13.996 7.23641 13.996 7.50161 13.996 7.76682C13.996 8.03203 13.996 8.29724 13.996 8.56244C13.996 8.82765 13.996 9.09286 13.996 9.35807C13.996 9.62327 13.996 9.88848 13.996 10.1537C13.996 10.4189 13.996 10.6841 13.996 10.9493C13.996 11.2145 13.996 11.4797 13.996 11.7449C13.996 12.0101 13.996 12.2753 13.996 12.5406C13.996 12.8058 13.996 13.071 13.996 13.3362C13.996 13.6014 13.996 13.8666 13.996 14.1318C13.996 14.397 13.996 14.6622 13.996 14.9274C13.996 15.06 13.9961 15.1926 14 15.3214C14 15.4086 13.996 15.4957 13.9921 15.5829C13.9921 15.8102 13.9842 16.0261 13.9368 16.2421ZM5.71848 11.7866C5.71848 12.2943 5.71848 12.802 5.71848 13.3134C5.71848 13.3362 5.71848 13.3589 5.71848 13.3779C5.71848 13.4119 5.73032 13.4309 5.76982 13.4309C5.78956 13.4309 5.80931 13.4309 5.82906 13.4309C6.18843 13.4309 6.54781 13.4309 6.90324 13.4309C7.09281 13.4309 7.27842 13.4119 7.46403 13.3665C7.58646 13.3362 7.70889 13.2983 7.82341 13.2452C8.07221 13.1354 8.28152 12.98 8.43949 12.7603C8.61721 12.5102 8.69224 12.2261 8.71594 11.9306C8.73568 11.6654 8.70409 11.4077 8.61721 11.1577C8.55797 10.9834 8.46319 10.8243 8.33286 10.6841C8.17884 10.5174 7.98928 10.4 7.77997 10.3128C7.69704 10.2787 7.61016 10.2522 7.52327 10.2257C7.43244 10.1992 7.34161 10.1764 7.25078 10.1688C7.05331 10.1499 6.85585 10.1423 6.65839 10.1461C6.38984 10.1499 6.11735 10.1461 5.8488 10.1461C5.82511 10.1461 5.80141 10.1461 5.78166 10.1461C5.73822 10.1461 5.71453 10.1651 5.71848 10.2067C5.71848 10.2295 5.71848 10.2522 5.71848 10.2711C5.71848 10.7788 5.71848 11.2827 5.71848 11.7866ZM2.71707 11.779C2.71707 12.1276 2.71707 12.4724 2.71707 12.8209C2.71707 12.999 2.71707 13.1733 2.71707 13.3513C2.71707 13.4309 2.71707 13.4347 2.8079 13.4347C2.94217 13.4347 3.07645 13.4347 3.21072 13.4347C3.31735 13.4347 3.42003 13.4347 3.52666 13.4347C3.578 13.4347 3.60169 13.4157 3.59774 13.3665C3.59774 13.3438 3.59774 13.321 3.59774 13.3021C3.59774 12.9838 3.59774 12.6656 3.59774 12.3473C3.59774 12.2526 3.60169 12.2526 3.69647 12.2526C3.90973 12.2526 4.12299 12.2564 4.33625 12.245C4.47842 12.2375 4.61269 12.1996 4.74697 12.1427C5.15769 11.9647 5.33145 11.6464 5.3591 11.2372C5.367 11.0971 5.3354 10.9645 5.29196 10.8319C5.16164 10.4303 4.77066 10.2067 4.40733 10.1688C4.13484 10.1385 3.86234 10.1537 3.58984 10.1499C3.33315 10.1499 3.07645 10.1499 2.81975 10.1499C2.71707 10.1499 2.71707 10.1499 2.71707 10.2522C2.71707 10.2711 2.71707 10.2901 2.71707 10.309C2.71707 10.794 2.71707 11.2865 2.71707 11.779ZM9.1701 11.7904C9.1701 12.2829 9.1701 12.7755 9.1701 13.268C9.1701 13.3021 9.1701 13.3362 9.1701 13.3703C9.16615 13.4157 9.1859 13.4309 9.23329 13.4309C9.36756 13.4271 9.50183 13.4309 9.63611 13.4309C9.75063 13.4309 9.86516 13.4309 9.97969 13.4309C10.0231 13.4309 10.0468 13.4157 10.0429 13.3703C10.0389 13.3475 10.0429 13.3248 10.0429 13.3059C10.0429 12.9308 10.0429 12.5557 10.0429 12.1806C10.0429 12.0973 10.0429 12.0973 10.1298 12.0973C10.1456 12.0973 10.1614 12.0973 10.1772 12.0973C10.5207 12.0973 10.8604 12.0973 11.2039 12.0973C11.2869 12.0973 11.2869 12.0973 11.2869 12.0215C11.2869 11.8548 11.2869 11.6881 11.2869 11.5214C11.2869 11.3888 11.3145 11.3964 11.1526 11.3964C10.809 11.3964 10.4694 11.3964 10.1258 11.3964C10.0468 11.3964 10.0429 11.3964 10.0389 11.3395C10.035 11.1994 10.0389 11.063 10.0389 10.9228C10.0389 10.8811 10.0587 10.866 10.0982 10.8697C10.1219 10.8697 10.1456 10.8697 10.1653 10.8697C10.6076 10.8697 11.046 10.8697 11.4883 10.8697C11.587 10.8697 11.587 10.8697 11.587 10.7788C11.587 10.6008 11.587 10.4265 11.587 10.2484C11.587 10.1537 11.587 10.1537 11.4883 10.1537C10.7458 10.1537 9.99944 10.1537 9.25698 10.1537C9.15825 10.1537 9.15825 10.1537 9.15825 10.2484C9.15825 10.2636 9.15825 10.2787 9.15825 10.2939C9.1701 10.7864 9.1701 11.2903 9.1701 11.7904Z"
          fill="#E5262B"
        />
        <path
          d="M13.9843 5.28519C13.9053 5.27003 13.8223 5.27382 13.7394 5.27382C12.1123 5.27382 10.4852 5.27382 8.85421 5.27382C8.6844 5.27382 8.70414 5.28897 8.70414 5.13364C8.70414 3.4742 8.70414 1.81476 8.70414 0.155318C8.70414 0.109854 8.70414 0.0606008 8.7002 0.0151367C8.78708 0.0681782 8.85027 0.14774 8.92135 0.219725C9.21754 0.515242 9.51374 0.810759 9.80993 1.11006C10.1733 1.48135 10.5484 1.83749 10.9039 2.21257C11.1171 2.4361 11.3462 2.64827 11.5634 2.86801C11.7924 3.09533 12.0175 3.32644 12.2466 3.55376C12.5546 3.86443 12.8666 4.17131 13.1747 4.48199C13.4353 4.7434 13.6999 5.00482 13.9606 5.27003C13.9764 5.26624 13.9803 5.27761 13.9843 5.28519Z"
          fill="#ED686B"
        />
        <path
          d="M5.71844 11.7866C5.71844 11.2827 5.71844 10.775 5.71844 10.2711C5.71844 10.2484 5.71844 10.2257 5.71844 10.2067C5.71449 10.1612 5.73819 10.1423 5.78163 10.1461C5.80533 10.1461 5.82902 10.1461 5.84877 10.1461C6.11732 10.1461 6.38981 10.1499 6.65836 10.1461C6.85582 10.1423 7.05328 10.1499 7.25074 10.1688C7.34157 10.1764 7.43241 10.2029 7.52324 10.2257C7.61012 10.2522 7.697 10.2787 7.77994 10.3128C7.98925 10.4037 8.17881 10.5212 8.33283 10.6841C8.46315 10.8243 8.55794 10.9834 8.61717 11.1577C8.70406 11.4077 8.73565 11.6653 8.7159 11.9306C8.69221 12.2261 8.61717 12.5102 8.43946 12.7603C8.28149 12.98 8.07218 13.1354 7.82338 13.2452C7.70885 13.2983 7.59038 13.3362 7.464 13.3665C7.27839 13.4119 7.09277 13.4309 6.90321 13.4309C6.54383 13.4309 6.18445 13.4309 5.82902 13.4309C5.80928 13.4309 5.78953 13.4309 5.76978 13.4309C5.73029 13.4309 5.71844 13.4119 5.71844 13.3778C5.71844 13.3551 5.71844 13.3324 5.71844 13.3134C5.71844 12.8057 5.71844 12.2943 5.71844 11.7866ZM6.57148 11.7866C6.57148 12.0669 6.57148 12.3473 6.57148 12.6277C6.57148 12.7148 6.57148 12.7148 6.66626 12.7148C6.86372 12.7186 7.06118 12.7148 7.24679 12.6542C7.41266 12.6012 7.56273 12.5216 7.67331 12.3814C7.79179 12.2299 7.82733 12.0518 7.84707 11.8699C7.86287 11.7108 7.83128 11.5517 7.77994 11.4001C7.73255 11.2562 7.64961 11.1425 7.52324 11.0554C7.35737 10.9379 7.16781 10.8811 6.96245 10.8659C6.85977 10.8584 6.75709 10.8621 6.65836 10.8621C6.57148 10.8621 6.57148 10.8621 6.57148 10.9455C6.57148 11.2259 6.57148 11.5062 6.57148 11.7866Z"
          fill="white"
        />
        <path
          d="M2.71704 11.7789C2.71704 11.2864 2.71704 10.7939 2.71704 10.3013C2.71704 10.2824 2.71704 10.2635 2.71704 10.2445C2.71704 10.146 2.71704 10.1422 2.81972 10.1422C3.07642 10.1422 3.33312 10.1422 3.58982 10.1422C3.86232 10.1422 4.13481 10.1309 4.40731 10.1612C4.77064 10.1991 5.16161 10.4226 5.29193 10.8242C5.33538 10.9568 5.36697 11.0894 5.35907 11.2296C5.33143 11.6388 5.15766 11.9608 4.74694 12.1351C4.61662 12.1919 4.47839 12.2298 4.33622 12.2374C4.12296 12.2487 3.90971 12.2412 3.69645 12.2449C3.60167 12.2449 3.59772 12.2487 3.59772 12.3397C3.59772 12.6579 3.59772 12.9762 3.59772 13.2944C3.59772 13.3171 3.59772 13.3399 3.59772 13.3588C3.60167 13.4081 3.57797 13.427 3.52663 13.427C3.42 13.427 3.31732 13.427 3.21069 13.427C3.07642 13.427 2.94215 13.427 2.80787 13.427C2.72099 13.427 2.72099 13.427 2.71704 13.3437C2.71704 13.1656 2.71704 12.9913 2.71704 12.8132C2.71704 12.4723 2.71704 12.1237 2.71704 11.7789ZM3.58192 11.1917C3.58192 11.2788 3.58192 11.3698 3.58192 11.4569C3.58192 11.5251 3.58982 11.5327 3.66091 11.5327C3.81493 11.5327 3.96895 11.5327 4.12296 11.5327C4.19405 11.5327 4.26119 11.5099 4.32043 11.4796C4.48234 11.3849 4.49814 11.2447 4.4705 11.1045C4.44285 10.9757 4.32043 10.8772 4.16641 10.8696C3.99659 10.8583 3.82282 10.8659 3.65301 10.8659C3.58982 10.8659 3.58192 10.8772 3.58192 10.9416C3.58192 11.0212 3.58192 11.1083 3.58192 11.1917Z"
          fill="white"
        />
        <path
          d="M9.17017 11.7904C9.17017 11.2903 9.17017 10.7864 9.17017 10.2863C9.17017 10.2711 9.17017 10.256 9.17017 10.2408C9.17017 10.1461 9.17017 10.1461 9.2689 10.1461C10.0114 10.1461 10.7578 10.1461 11.5002 10.1461C11.5989 10.1461 11.5989 10.1461 11.5989 10.2408C11.5989 10.4189 11.5989 10.5932 11.5989 10.7712C11.5989 10.8622 11.595 10.8622 11.5002 10.8622C11.0579 10.8622 10.6195 10.8622 10.1772 10.8622C10.1535 10.8622 10.1298 10.8622 10.1101 10.8622C10.0706 10.8584 10.0469 10.8735 10.0508 10.9152C10.0508 11.0554 10.0508 11.1918 10.0508 11.332C10.0508 11.3888 10.0548 11.3888 10.1377 11.3888C10.4813 11.3888 10.8209 11.3888 11.1645 11.3888C11.3225 11.3888 11.2948 11.385 11.2988 11.5138C11.2988 11.6805 11.2988 11.8472 11.2988 12.0139C11.2988 12.0897 11.2988 12.0897 11.2159 12.0897C10.8723 12.0897 10.5326 12.0897 10.1891 12.0897C10.1733 12.0897 10.1575 12.0897 10.1417 12.0897C10.0548 12.0897 10.0548 12.0897 10.0548 12.1731C10.0548 12.5481 10.0548 12.9232 10.0548 13.2983C10.0548 13.321 10.0548 13.3438 10.0548 13.3627C10.0587 13.4082 10.035 13.4233 9.9916 13.4233C9.87708 13.4233 9.76255 13.4233 9.64802 13.4233C9.51375 13.4233 9.37948 13.4233 9.2452 13.4233C9.19781 13.4233 9.17806 13.4082 9.18201 13.3627C9.18201 13.3286 9.18201 13.2945 9.18201 13.2604C9.17017 12.7755 9.17017 12.2829 9.17017 11.7904Z"
          fill="white"
        />
        <path
          d="M6.57153 11.7866C6.57153 11.5062 6.57153 11.2259 6.57153 10.9455C6.57153 10.8622 6.57153 10.8622 6.65842 10.8622C6.7611 10.8622 6.86378 10.8584 6.96251 10.8659C7.16787 10.8811 7.35743 10.9379 7.5233 11.0554C7.64967 11.1425 7.73261 11.2562 7.78 11.4001C7.83134 11.5555 7.86293 11.7108 7.84713 11.8699C7.82739 12.0518 7.79184 12.2299 7.67337 12.3814C7.56674 12.5216 7.41272 12.6012 7.24685 12.6542C7.05729 12.7148 6.85983 12.7186 6.66631 12.7148C6.57153 12.7148 6.57153 12.7148 6.57153 12.6277C6.57153 12.3473 6.57153 12.067 6.57153 11.7866Z"
          fill="#E5262B"
        />
        <path
          d="M3.58203 11.1918C3.58203 11.1084 3.58203 11.0213 3.58203 10.9379C3.58203 10.8735 3.59388 10.8622 3.65312 10.8622C3.82293 10.8622 3.9967 10.8584 4.16652 10.8659C4.32054 10.8735 4.44296 10.972 4.47061 11.1008C4.5022 11.241 4.48245 11.385 4.32054 11.4759C4.2613 11.51 4.19416 11.529 4.12308 11.529C3.96906 11.529 3.81504 11.5327 3.66102 11.529C3.58993 11.529 3.58203 11.5214 3.58203 11.4532C3.58203 11.3698 3.58203 11.2827 3.58203 11.1918Z"
          fill="#E5262B"
        />
      </g>
      <defs>
        <clipPath id="clip0_3453_74753">
          <rect width="14" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "file-doc": (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 14 18"
      fill="none"
    >
      <g clipPath="url(#clip0_3453_74729)">
        <path
          d="M2.29122 0.0104346C2.3382 0.00696102 2.38157 0.00348746 2.42493 0.00348746C2.58033 -0.00345966 2.73211 1.38983e-05 2.8875 1.38983e-05C3.2778 1.38983e-05 3.67171 1.38983e-05 4.062 1.38983e-05C4.8462 1.38983e-05 5.6304 1.38983e-05 6.41461 1.38983e-05C7.1699 1.38983e-05 7.9288 1.38983e-05 8.6841 1.38983e-05C8.6841 1.69511 8.6841 3.39021 8.6841 5.08531C8.6841 5.30067 8.65157 5.27635 8.87924 5.27635C10.5091 5.27635 12.1425 5.27635 13.776 5.27635C13.8338 5.27635 13.8916 5.27635 13.9458 5.27635C13.9928 5.29025 13.9964 5.33193 14 5.36667C14.0037 5.4014 14 5.43614 14 5.47087C14 8.11425 14 10.7542 14 13.3975C14 14.1096 14 14.8217 14 15.5338C14 15.7804 13.9856 16.0236 13.9169 16.2632C13.8663 16.4369 13.8013 16.6036 13.7146 16.7634C13.5375 17.0795 13.299 17.3435 12.9954 17.5554C12.6991 17.7638 12.3666 17.8889 12.0088 17.9653C11.9618 17.9618 11.9185 17.9618 11.8751 17.9757C11.8173 17.9965 11.7559 17.9965 11.698 18C11.6366 18 11.5716 18.0035 11.5101 18.0035C8.5034 18.0035 5.50031 18.0035 2.4936 18.0035C2.17196 18.0035 1.85395 17.9549 1.554 17.8402C1.52147 17.8263 1.48895 17.8159 1.45642 17.802C1.43474 17.7916 1.40944 17.7812 1.38776 17.7708C1.34801 17.7534 1.30826 17.7325 1.26489 17.7152C1.23237 17.6909 1.19623 17.67 1.16009 17.6492C0.870983 17.4859 0.628856 17.2601 0.437322 16.9962C0.271086 16.7669 0.140988 16.496 0.072325 16.2285C0.0650973 16.2077 0.0614835 16.1868 0.0578697 16.166C0.0542558 16.1417 0.050642 16.1139 0.0434143 16.0896C0.0361866 16.0444 0.0217313 15.9992 0.0145036 15.9541C0.00727595 15.9089 0.0108898 15.8672 0.00727595 15.8221C0.00366211 15.7214 0.00366211 15.6206 0.00366211 15.5199C0.00366211 15.3184 0.00366211 15.117 0.00366211 14.9155C0.00366211 14.8425 0.00366211 14.7661 0.00366211 14.6932C0.00366211 14.2902 0.00366211 13.8838 0.00366211 13.4809C0.00366211 13.078 0.00366211 12.6716 0.00366211 12.2686C0.00366211 11.8657 0.00366211 11.4593 0.00366211 11.0564C0.00366211 10.6534 0.00366211 10.247 0.00366211 9.84409C0.00366211 9.44116 0.00366211 9.03475 0.00366211 8.63181C0.00366211 8.22888 0.00366211 7.82248 0.00366211 7.41954C0.00366211 7.01661 0.00366211 6.6102 0.00366211 6.20727C0.00366211 5.80434 0.00366211 5.39793 0.00366211 4.995C0.00366211 4.59206 0.00366211 4.18566 0.00366211 3.78272C0.00366211 3.37979 0.00366211 2.97338 0.00366211 2.57045C0.00366211 2.28214 0.00727595 2.01121 0.0867803 1.73332C0.162671 1.45891 0.292769 1.19839 0.466233 0.969138C0.679449 0.684306 0.957715 0.451577 1.27935 0.284846C1.43836 0.20148 1.60821 0.135483 1.78528 0.0903265C1.94791 0.0451702 2.12137 0.0243288 2.29122 0.0104346ZM2.25508 11.3516C2.25508 11.8067 2.25508 12.2617 2.25508 12.7133C2.25508 12.7341 2.25508 12.7549 2.25508 12.7723C2.25147 12.8175 2.27676 12.8348 2.32013 12.8348C2.33097 12.8348 2.34543 12.8348 2.35627 12.8348C2.68513 12.8348 3.01399 12.8314 3.33923 12.8348C3.61388 12.8383 3.88131 12.7966 4.13428 12.6855C4.31858 12.6056 4.48482 12.5014 4.62214 12.3555C4.85704 12.1054 4.951 11.7997 4.97991 11.4732C4.99076 11.3273 4.97991 11.1849 4.95823 11.0425C4.92209 10.8097 4.83897 10.5944 4.69081 10.4138C4.427 10.0942 4.062 9.94135 3.65364 9.87882C3.55606 9.86493 3.45488 9.86146 3.3573 9.86146C3.02844 9.85798 2.69958 9.86146 2.37434 9.86146C2.26592 9.86146 2.26231 9.86493 2.26231 9.96914C2.25508 10.4311 2.25508 10.8931 2.25508 11.3516ZM6.85549 9.83714C6.64951 9.83367 6.44713 9.85798 6.2556 9.92745C5.96288 10.0351 5.72075 10.2088 5.53283 10.4554C5.35214 10.6916 5.26902 10.9591 5.24734 11.2474C5.2365 11.3829 5.24734 11.5183 5.27263 11.6538C5.30155 11.7962 5.34491 11.9317 5.40996 12.0602C5.5256 12.2895 5.69907 12.4736 5.91228 12.616C6.1508 12.7723 6.41822 12.8626 6.70733 12.873C6.8049 12.8765 6.90609 12.8696 7.00366 12.873C7.11208 12.8765 7.21326 12.8522 7.31445 12.8244C7.50237 12.7758 7.67584 12.6959 7.83123 12.5813C8.19984 12.3173 8.40222 11.9595 8.4492 11.5253C8.47088 11.3169 8.45281 11.105 8.39137 10.9001C8.32633 10.6812 8.21068 10.4902 8.05529 10.3234C7.85653 10.115 7.6144 9.97608 7.33252 9.89272C7.18074 9.84061 7.01812 9.84409 6.85549 9.83714ZM10.3284 9.83367C10.1549 9.83714 9.98508 9.84062 9.82245 9.88925C9.65622 9.93787 9.50082 10.0039 9.35627 10.1011C9.2081 10.2019 9.078 10.3234 8.97682 10.4693C8.80697 10.7125 8.74914 10.9869 8.72746 11.2717C8.71662 11.3968 8.74192 11.5183 8.75276 11.6434C8.75999 11.7268 8.77806 11.8032 8.80335 11.8796C8.85395 12.0394 8.92984 12.1887 9.03825 12.3242C9.25147 12.5847 9.53335 12.7445 9.85859 12.8314C10.0212 12.8765 10.1911 12.873 10.3609 12.873C10.5705 12.873 10.7729 12.8383 10.968 12.7654C11.268 12.6507 11.492 12.4597 11.6402 12.1887C11.6727 12.1297 11.6944 12.0637 11.7161 11.9977C11.7233 11.9734 11.745 11.9352 11.6944 11.9178C11.6041 11.8865 11.5101 11.8726 11.4162 11.8553C11.2716 11.824 11.127 11.7928 10.9789 11.7615C10.9391 11.7545 10.9211 11.7684 10.9138 11.7997C10.8452 12.0498 10.6645 12.1818 10.4115 12.2235C10.1983 12.2582 9.99592 12.2061 9.82607 12.0706C9.67067 11.9491 9.58755 11.7893 9.55142 11.6017C9.50805 11.3829 9.51528 11.171 9.59478 10.9626C9.69597 10.6916 9.90196 10.5353 10.1875 10.4867C10.3681 10.4554 10.5416 10.4971 10.6934 10.6048C10.8235 10.6986 10.8994 10.8236 10.9464 10.966C10.9608 11.0182 10.9825 11.0182 11.0295 11.0147C11.1054 11.0043 11.1776 10.9869 11.2499 10.973C11.3909 10.9487 11.5318 10.9209 11.6727 10.8931C11.7161 10.8862 11.7306 10.8653 11.7306 10.8202C11.7233 10.7125 11.6908 10.6083 11.6402 10.5145C11.4668 10.1776 11.1704 9.9865 10.8018 9.88577C10.6392 9.84062 10.4802 9.84409 10.3284 9.83367Z"
          fill="#0263D1"
        />
        <path
          d="M8.72007 5.55937e-05C8.72007 0.0347912 8.75259 0.052159 8.77428 0.0730004C9.42477 0.72603 10.0716 1.37906 10.7221 2.02862C11.2859 2.59481 11.8497 3.161 12.4098 3.72371C12.9121 4.22738 13.4108 4.73105 13.9132 5.23124C13.924 5.24514 13.9421 5.25208 13.9421 5.27292C13.8842 5.27292 13.8264 5.27292 13.7722 5.27292C12.1424 5.27292 10.5089 5.27292 8.87546 5.27292C8.64779 5.27292 8.68032 5.29724 8.68032 5.08188C8.68032 3.38678 8.68032 1.69168 8.68032 -0.00341797C8.69477 5.55937e-05 8.70561 5.55937e-05 8.72007 5.55937e-05Z"
          fill="#4E92DF"
        />
        <path
          d="M2.25513 11.3516C2.25513 10.893 2.25513 10.4311 2.25513 9.97255C2.25513 9.87182 2.25874 9.86487 2.36716 9.86487C2.69602 9.86487 3.02487 9.86487 3.35012 9.86487C3.44769 9.86487 3.54888 9.86834 3.64645 9.88224C4.05843 9.94129 4.41982 10.0976 4.68363 10.4172C4.83541 10.5978 4.91491 10.8166 4.95105 11.0459C4.97273 11.1883 4.98719 11.3342 4.97273 11.4766C4.94744 11.8031 4.84986 12.1088 4.61496 12.3589C4.47764 12.5048 4.3114 12.609 4.12709 12.6889C3.87413 12.8 3.6067 12.8382 3.33205 12.8382C3.00319 12.8348 2.67433 12.8382 2.34909 12.8382C2.33825 12.8382 2.32379 12.8382 2.31295 12.8382C2.26958 12.8382 2.24429 12.8209 2.2479 12.7757C2.2479 12.7549 2.2479 12.734 2.2479 12.7167C2.25513 12.2616 2.25513 11.8066 2.25513 11.3516ZM3.03933 11.3516C3.03933 11.3793 3.03933 11.4106 3.03933 11.4384C3.03933 11.6676 3.03933 11.8934 3.03933 12.1227C3.03933 12.1956 3.04294 12.1956 3.11522 12.1956C3.30675 12.1991 3.49829 12.1956 3.68259 12.1262C3.78739 12.0845 3.88497 12.0358 3.96809 11.9594C4.09457 11.8448 4.15601 11.6954 4.17769 11.5357C4.20299 11.3377 4.20299 11.1397 4.11264 10.9521C4.05843 10.8409 3.99338 10.7437 3.88135 10.6777C3.76933 10.6082 3.65368 10.5631 3.52358 10.5353C3.38264 10.504 3.24171 10.5179 3.10438 10.5075C3.0574 10.504 3.03933 10.5214 3.04294 10.5665C3.04294 10.5874 3.04294 10.6082 3.04294 10.6256C3.03933 10.8722 3.03933 11.1119 3.03933 11.3516Z"
          fill="#FAFCFE"
        />
        <path
          d="M6.85556 9.83716C7.01818 9.8441 7.1808 9.84063 7.3362 9.88926C7.61446 9.97262 7.8602 10.1116 8.05896 10.32C8.21797 10.4867 8.33 10.6778 8.39505 10.8966C8.45648 11.1015 8.47817 11.3134 8.45287 11.5218C8.40589 11.956 8.20352 12.3138 7.83491 12.5778C7.67951 12.6924 7.50605 12.7723 7.31813 12.8209C7.21694 12.8453 7.11575 12.8696 7.00734 12.8696C6.90976 12.8661 6.80858 12.873 6.711 12.8696C6.41828 12.8592 6.15447 12.7688 5.91596 12.6125C5.69913 12.4701 5.52928 12.286 5.41364 12.0568C5.34859 11.9282 5.30161 11.7928 5.27631 11.6504C5.25101 11.5149 5.24017 11.3794 5.25101 11.2439C5.2727 10.9556 5.35581 10.6882 5.53651 10.452C5.72442 10.2054 5.96655 10.0317 6.25927 9.92399C6.44719 9.85452 6.64957 9.83368 6.85556 9.83716ZM6.04244 11.362C6.02799 11.5184 6.06774 11.6816 6.15808 11.831C6.28818 12.0498 6.48333 12.1888 6.74353 12.22C6.98927 12.2513 7.20971 12.1922 7.39763 12.0255C7.53134 11.9074 7.61807 11.7546 7.6506 11.5844C7.6759 11.4663 7.67951 11.3447 7.66505 11.2231C7.64699 11.0494 7.58916 10.8966 7.47713 10.7611C7.32535 10.577 7.12659 10.4832 6.88447 10.4728C6.80858 10.4693 6.73269 10.4798 6.65318 10.4971C6.5267 10.5284 6.4219 10.5805 6.32794 10.6639C6.12195 10.8514 6.0316 11.0772 6.04244 11.362Z"
          fill="#FAFCFE"
        />
        <path
          d="M10.3284 9.83362C10.4802 9.84404 10.6428 9.84057 10.7982 9.88225C11.1668 9.98298 11.4595 10.1775 11.6366 10.511C11.6872 10.6047 11.7197 10.7055 11.727 10.8166C11.7306 10.8618 11.7125 10.8826 11.6691 10.8896C11.5282 10.9174 11.3873 10.9417 11.2463 10.9695C11.174 10.9834 11.1018 11.0042 11.0259 11.0112C10.9789 11.0181 10.9572 11.0146 10.9428 10.9625C10.8994 10.8166 10.8199 10.6916 10.6898 10.6013C10.538 10.4936 10.3645 10.4484 10.1838 10.4832C9.89835 10.5318 9.69237 10.6881 9.59118 10.9591C9.51167 11.1675 9.50445 11.3794 9.54781 11.5982C9.58395 11.7858 9.66707 11.9455 9.82246 12.0671C9.99593 12.2026 10.1947 12.2547 10.4079 12.22C10.6609 12.1783 10.8416 12.0463 10.9102 11.7962C10.9211 11.7649 10.9355 11.751 10.9753 11.758C11.1198 11.7892 11.2644 11.8205 11.4126 11.8518C11.5065 11.8726 11.6005 11.8865 11.6908 11.9143C11.7378 11.9316 11.7197 11.9699 11.7125 11.9942C11.6908 12.0602 11.6691 12.1262 11.6366 12.1852C11.4884 12.4596 11.2644 12.6507 10.9644 12.7618C10.7693 12.8348 10.5669 12.8695 10.3573 12.8695C10.1875 12.8695 10.0212 12.8695 9.85499 12.8278C9.52974 12.741 9.24786 12.5812 9.03465 12.3207C8.92623 12.1852 8.84673 12.0359 8.79975 11.8761C8.77445 11.7997 8.75638 11.7232 8.74915 11.6399C8.73831 11.5148 8.71663 11.3932 8.72386 11.2682C8.74554 10.9834 8.80698 10.7055 8.97321 10.4658C9.0744 10.3199 9.2045 10.2018 9.35266 10.0976C9.4936 10.0003 9.65261 9.93435 9.81885 9.88572C9.98509 9.84404 10.1549 9.83709 10.3284 9.83362Z"
          fill="#FAFCFE"
        />
        <path
          d="M3.03926 11.3516C3.03926 11.1119 3.03926 10.8722 3.03926 10.6326C3.03926 10.6117 3.03926 10.5909 3.03926 10.5735C3.03564 10.5284 3.05371 10.511 3.10069 10.5145C3.24163 10.5214 3.37896 10.5075 3.5199 10.5423C3.65 10.57 3.76925 10.6152 3.87767 10.6847C3.98608 10.7507 4.05475 10.8479 4.10895 10.9591C4.1993 11.1467 4.1993 11.3481 4.174 11.5426C4.15232 11.699 4.09088 11.8483 3.9644 11.9664C3.88128 12.0428 3.78371 12.0915 3.67891 12.1331C3.4946 12.2026 3.30307 12.2061 3.11154 12.2026C3.03926 12.2026 3.03564 12.2026 3.03564 12.1297C3.03564 11.9004 3.03564 11.6746 3.03564 11.4454C3.03926 11.4072 3.03926 11.3794 3.03926 11.3516Z"
          fill="#0565D2"
        />
        <path
          d="M6.04244 11.362C6.0316 11.0772 6.12556 10.8514 6.33155 10.6673C6.42551 10.5839 6.53031 10.5318 6.65679 10.5006C6.73268 10.4832 6.80858 10.4728 6.88808 10.4763C7.13021 10.4867 7.32897 10.577 7.48075 10.7646C7.59278 10.9 7.6506 11.0529 7.66867 11.2265C7.68312 11.3481 7.6759 11.4697 7.65421 11.5878C7.62169 11.758 7.53496 11.9074 7.40124 12.0289C7.21694 12.1922 6.99288 12.2547 6.74714 12.2235C6.48694 12.1887 6.2918 12.0532 6.1617 11.8344C6.06774 11.6816 6.02799 11.5183 6.04244 11.362Z"
          fill="#0565D2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3453_74729">
          <rect width="14" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
}
